import CheckIcon from '@mui/icons-material/Check';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import {
  Alert,
  Box,
  Button,
  Container,
  Grid,
  Paper,
  Rating,
  Stack,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
} from '@mui/material';

// import React from 'react';
import Hidden from '@/components/ui/TzoHidden';
import AppLayout from '@/layouts/AppLayout';
import { Meta } from '@/layouts/Meta';

const BestForm941Software = () => {
  // const containerRef = useRef(null);

  // const [currentImageIndex, setCurrentImageIndex] = useState(0);
  // const [removelistener, setRemovelistener] = useState(true);
  // const [tempReturn, setTempReturn] = useState(false);
  // Define an array of imported images
  // const images = [
  //   '/assets/images/2290-steps-img.webp',
  //   '/assets/images/easy-steps-img.webp',
  //   '/assets/images/941-steps-img.webp',

  // ];
  // const Ref = React.useRef<HTMLDivElement>(null);

  // Handle scrolling to change images
  // const handleScroll = (event: any) => {
  //   const delta = event.deltaY;
  //   if (delta > 0) {
  //     // Scroll down, show the next imag
  //     if (currentImageIndex < 2) {
  //       setCurrentImageIndex((prevIndex) => (prevIndex + 1) % images.length);
  //       setRemovelistener(false);
  //     } else {
  //       setRemovelistener(true);
  //     }
  //   } else if (delta < 0) {
  //     // Scroll up, show the previous image
  //     if (currentImageIndex > 0) {
  //       setCurrentImageIndex((prevIndex) =>
  //         prevIndex === 0 ? images.length - 1 : prevIndex - 1
  //       );
  //       setRemovelistener(false);
  //     } else {
  //       setRemovelistener(true);
  //     }
  //   } else {
  //     setRemovelistener(false);
  //   }
  // };
  // function useHorizontalScroll() {
  //   useEffect(() => {
  //     const el = Ref.current;
  //     setTempReturn(tempReturn);
  //     if (el) {
  //       const onWheel = (e: any) => {
  //         if (e.deltaY === 0) return;
  //         e.preventDefault();
  //         el.scrollTo({
  //           behavior: 'smooth',
  //           top: 0,
  //           left: 0,
  //         });
  //       };

  //       el.addEventListener('wheel', onWheel);
  //       if (removelistener === false) {
  //         el.addEventListener('wheel', onWheel);
  //       } else if (removelistener === true) {
  //         el.removeEventListener('wheel', onWheel);
  //       } else {
  //         el.addEventListener('wheel', onWheel);
  //       }
  //       return () => {
  //         el.removeEventListener('wheel', onWheel);
  //       };
  //     }
  //     return () => setTempReturn(false);
  //   }, [removelistener]);
  //   return Ref;
  // }

  // const scrollRef = useHorizontalScroll();

  return (
    <AppLayout
      // LayoutWrapperContents={layoutWrapperContents}
      meta={
        <Meta
          title="TaxZerone vs SimpleTruckTax: 2026 Form 2290 Comparison"
          description="Compare TaxZerone vs SimpleTruckTax pricing, tools, and support. Discover why fleet managers and accountants choose TaxZerone for Form 2290 e-filing."
          keywords=""
          canonical="comparison/taxzerone-vs-simpletrucktax/"
          // noFollowContent="noindex, nofollow"
          // jsonLdPricing="89.99"
          // jsonLdAggregateRatingValue="4.99"
          // jsonLdAggregateRatingCount="3021"
        />
      }
    >
      <Box
        component="section"
        sx={{
          mt: 0,
          pt: 8,
          pb: 8,
          position: 'relative',
          background: `
  linear-gradient(180deg,rgba(34, 62, 152, 0.32) 0%, rgba(243, 113, 40, 0.08) 66%, rgba(255, 255, 255, 0.34) 97%)
`,
          overflow: 'hidden',
        }}
      >
        <Container
          maxWidth="lg"
          sx={{
            alignContent: 'center',
            justifyContent: 'center',
            textAlign: 'center',
          }}
        >
          <Box
            sx={{
              textAlign: 'center',
              mt: 4,
              mb: 4,
            }}
          >
            <Typography
              variant="body1"
              sx={{
                fontWeight: 500,
                backgroundColor: 'rgb(33, 62, 153, 0.1)',
                color: '#213E99',
                border: '1px solid #5c74c4',
                display: 'inline-block',
                px: 4,
                py: 1,
                borderRadius: 24,
                alignItems: 'center',
                mb: 2,
              }}
            >
              <Box
                component="span"
                sx={{
                  width: 8,
                  height: 8,
                  minWidth: 8,
                  borderRadius: '50%',
                  backgroundColor: '#213e99',
                  display: 'inline-block',
                  gap: 2,
                  animation:
                    'pulseDot 3.8s cubic-bezier(0.5, 0, 0.6, 1) infinite',

                  '@keyframes pulseDot': {
                    '0%': {
                      transform: 'scale(0.5)',
                      boxShadow: '0 0 0 0 rgba(33, 62, 153, 0.5)',
                    },
                    '50%': {
                      transform: 'scale(1.1)',
                      boxShadow: '0 0 0 7px rgba(33, 62, 153, 0)',
                    },
                    '100%': {
                      transform: 'scale(0.5)',
                      boxShadow: '0 0 0 0 rgba(33, 62, 153, 0)',
                    },
                  },
                }}
              />
              &nbsp; Form 2290 – Heavy Vehicle Use Tax
            </Typography>
            <Typography
              variant="h1"
              sx={{
                fontSize: {
                  xs: 24,
                  sm: 30,
                  md: 38,
                  lg: 48,
                  xl: 56,
                },
                fontWeight: 700,
                color: '#1a1a1a',
                mb: 3,
                lineHeight: 1.2,
              }}
            >
              TaxZerone <span style={{ color: '#5B4FCB' }}> vs</span>{' '}
              SimpleTruckTax
            </Typography>

            <Typography
              variant="body1"
              sx={{
                fontSize: {
                  xs: 16,
                  sm: 18,
                  md: 20,
                  lg: 22,
                  xl: 24,
                },
                fontWeight: 400,
                mb: 1,
                // color: '#5b6472',
                lineHeight: 1.5,
                maxWidth: 1100,
                mx: 'auto',
              }}
            >
              <strong style={{ fontWeight: 600 }}>
                {' '}
                Trying to decide between TaxZerone and SimpleTruckTax?
              </strong>{' '}
            </Typography>
            <Typography
              variant="body1"
              sx={{
                fontSize: {
                  xs: 16,
                  sm: 16,
                  md: 18,
                  lg: 18,
                },
                fontWeight: 'normal',
                mb: 4,
                // color: '#5b6472',
                lineHeight: 1.5,
                maxWidth: 1100,
                mx: 'auto',
              }}
            >
              Compare key features, filing experience, tools and support options
              to find <br />
              the right Form 2290 e-file solution for your trucking business.
            </Typography>

            <Button
              variant="contained"
              className="btn-primary"
              sx={{
                backgroundColor: '#1e2f8f',
                color: '#ffffff',
                fontWeight: 500,
                fontSize: 16,
                px: 4,
                py: 1.5,
                borderRadius: 2,
                textTransform: 'none',
                boxShadow: 'none',
                transition: 'all 0.3s ease',
                '&:hover, &:focus, &:active': {
                  backgroundColor: '#16247a',
                  transform: 'scale(1.05)',
                },
              }}
              href="#compare"
            >
              Compare Your Options
            </Button>
          </Box>
        </Container>
      </Box>
      <Grid
        container
        sx={{
          backgroundColor: '#ffffff',
          mx: '0 !important',
          width: '100% !important',
          backgroundPosition: 'center bottom',
          flexDirection: 'column',
        }}
        spacing={2}
        m={0}
        component="section"
      >
        <Container maxWidth="lg" sx={{ mt: 4, mb: 8 }}>
          <Grid
            container
            spacing={2}
            sx={{ mt: { xs: 2, sm: 6, md: 6 } }}
            className="MuiGrid-root-width"
          >
            <Grid size={12} textAlign="center">
              <Typography
                variant="h2"
                sx={{
                  fontSize: {
                    xs: 20,
                    sm: 28,
                    md: 32,
                    lg: 38,
                  },
                  fontWeight: 600,
                  mb: 1,
                  textAlign: 'center',
                  lineHeight: 1.5,
                }}
              >
                How TaxZerone and SimpleTruckTax Really Compare
              </Typography>
            </Grid>
            <Grid size={{ md: 6, sm: 6, xs: 12 }} textAlign="center">
              <Box>
                <picture>
                  <source srcSet="/assets/images/f2290-tzo-vs-smiple-img.webp" />
                  <source srcSet="/assets/images/f2290-tzo-vs-smiple-img.png" />
                  <Box
                    sx={{
                      width: '100%',
                      maxWidth: {
                        xs: 300,
                        sm: 380,
                        md: 450,
                      },
                      mx: 'auto',
                    }}
                    component="img"
                    src="/assets/images/f2290-tzo-vs-smiple-img.png"
                    loading="lazy"
                    alt="How TaxZerone and Simple Truck Tax Really Compare"
                  />
                </picture>
              </Box>
            </Grid>
            <Grid
              size={{ md: 6, sm: 6, xs: 12 }}
              sx={{
                textAlign: { md: 'left', sm: 'left', xs: 'center' },
                alignItems: 'center',
                justifyItems: 'center',
                display: 'flex',
              }}
            >
              <Box component="ul" sx={{ mb: 0, '& li': { mb: 1.2 } }}>
                <li>
                  TaxZerone and SimpleTruckTax are both IRS-authorized Form 2290
                  e-file providers, but they differ in features, workflows,
                  tools and overall filing experience.
                </li>

                <li>
                  When choosing Form 2290 software, it's important to consider
                  factors such as ease of use, filing features, VIN correction
                  options, amendments, customer support, and additional
                  services.
                </li>
                <li>
                  This comparison helps you evaluate the best Form 2290 e-file
                  software that meets your business needs.
                </li>
              </Box>
            </Grid>
          </Grid>
        </Container>
      </Grid>
      <Box
        sx={{
          backgroundColor: '#eef9fa',
          my: { xs: 0, md: 8 },
          py: { xs: 4, md: 4 },
        }}
        component="section"
        aria-labelledby="why-business-compare"
      >
        <Container
          maxWidth="lg"
          sx={{ px: { xs: 2, md: 4 }, py: { xs: 4, md: 8 } }}
        >
          <Stack
            direction={{ xs: 'column', md: 'row' }}
            alignItems="center"
            justifyContent="space-between"
            spacing={4}
            sx={{ my: { xs: 0, md: -23 } }}
          >
            <Box
              sx={{
                flex: 1,
                maxWidth: { md: 560 },
              }}
            >
              <Typography
                variant="h2"
                sx={{
                  fontWeight: 600,

                  fontSize: {
                    xs: 20,
                    sm: 28,
                    md: 32,
                    lg: 38,
                  },
                  lineHeight: 1.3,
                  mb: 2,
                }}
              >
                Why Businesses Compare Form 2290 Software
              </Typography>

              <Typography
                sx={{
                  // lineHeight: 1.8,
                  color: '#4B5563',
                  fontSize: 15.5,
                  mb: 1,
                }}
              >
                Choosing the right Form 2290 software involves more than just
                comparing prices. Key factors include:
              </Typography>
              <Box component="ul" sx={{ mb: 2, '& li': { mb: 1.2 } }}>
                <li>
                  <strong style={{ fontWeight: 600 }}>
                    {' '}
                    Competitive pricing
                  </strong>{' '}
                  for your filing needs
                </li>
                <li>
                  <strong style={{ fontWeight: 600 }}>
                    {' '}
                    Amendments and VIN corrections
                  </strong>{' '}
                  when you need to update a return
                </li>
                <li>
                  <strong style={{ fontWeight: 600 }}>
                    {' '}
                    Fast Schedule 1 delivery
                  </strong>{' '}
                  after IRS acceptance
                </li>
                <li>
                  <strong style={{ fontWeight: 600 }}>
                    {' '}
                    Dedicated English and Spanish support
                  </strong>{' '}
                  when you need filing assistance
                </li>
                <li>
                  <strong style={{ fontWeight: 600 }}>
                    {' '}
                    Flexible vehicle filing options
                  </strong>{' '}
                  for individual trucks, multiple vehicles, and larger fleets
                </li>
              </Box>
            </Box>

            <Box
              sx={{
                position: 'relative',
                flex: 1,
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                justifyContent: 'center',
                width: '100%',
                maxWidth: { xs: 280, sm: 340, md: 380 },
                mx: 'auto',
                my: { xs: 0, md: 4 },

                px: { xs: 2, sm: 0 },
              }}
            >
              <Box
                component="img"
                src="/assets/images/compare-f2290-software-img.webp"
                alt="Why Businesses Compare Form 2290 Software"
                sx={{
                  width: '100%',
                  height: 'auto',
                  display: 'block',
                  position: 'relative',
                  zIndex: 1,
                }}
              />

              <Box
                sx={{
                  position: 'absolute',
                  top: { xs: '5%', sm: '12%', md: '20%' },
                  left: { xs: '-5%', sm: '-12%', md: '-15%' },
                  bgcolor: '#FBE4E0',
                  color: '#0F172A',
                  fontSize: { xs: 10, sm: 12, md: 14 },
                  fontWeight: 600,
                  px: { xs: 1.5, sm: 2, md: 2.5 },
                  py: { xs: 0.8, sm: 1.2, md: 1.5 },
                  borderRadius: 2,
                  boxShadow: '0 4px 12px rgba(0,0,0,0.08)',
                  zIndex: 2,
                  textAlign: 'center',
                  whiteSpace: 'nowrap',
                  opacity: 0.85,
                }}
              >
                Competitive pricing
              </Box>

              <Box
                sx={{
                  position: 'absolute',
                  top: { xs: '38%', sm: '40%', md: '42%' },
                  right: { xs: '-8%', sm: '-20%', md: '-24%' },
                  bgcolor: '#F7D9CE',
                  color: '#0F172A',
                  fontSize: { xs: 10, sm: 12, md: 14 },
                  fontWeight: 600,
                  px: { xs: 1.5, sm: 2, md: 2.5 },
                  py: { xs: 0.8, sm: 1.2, md: 1.5 },
                  borderRadius: 2,
                  textAlign: 'center',
                  boxShadow: '0 4px 12px rgba(0,0,0,0.08)',
                  zIndex: 2,
                  whiteSpace: 'nowrap',
                  opacity: 0.85,
                }}
              >
                Fast Schedule 1 delivery
              </Box>

              <Box
                sx={{
                  position: 'absolute',
                  top: { xs: '58%', sm: '54%', md: '50%' },
                  left: { xs: '-6%', sm: '-8%', md: '-4%' },
                  bgcolor: '#E3DEF7',
                  color: '#0F172A',
                  fontSize: { xs: 10, sm: 12, md: 14 },
                  fontWeight: 600,
                  px: { xs: 1.5, sm: 2, md: 2.5 },
                  py: { xs: 0.8, sm: 1.2, md: 1.5 },
                  borderRadius: 2,
                  textAlign: 'center',
                  boxShadow: '0 4px 12px rgba(0,0,0,0.08)',
                  zIndex: 2,
                  whiteSpace: 'nowrap',
                  opacity: 0.85,
                }}
              >
                Amendments and <br /> VIN corrections
              </Box>
              <Box
                sx={{
                  position: 'absolute',
                  top: { xs: '58%', sm: '54%', md: '65%' },
                  left: { xs: '-6%', sm: '-8%', md: '60%' },
                  bgcolor: '#f7f0de',
                  color: '#0F172A',
                  fontSize: { xs: 10, sm: 12, md: 14 },
                  fontWeight: 600,
                  px: { xs: 1.5, sm: 2, md: 2.5 },
                  py: { xs: 0.8, sm: 1.2, md: 1.5 },
                  borderRadius: 2,
                  textAlign: 'center',
                  boxShadow: '0 4px 12px rgba(0,0,0,0.08)',
                  zIndex: 2,
                  whiteSpace: 'nowrap',
                  opacity: 0.85,
                }}
              >
                Flexible vehicle filing options
              </Box>

              <Box
                sx={{
                  position: 'absolute',
                  bottom: { xs: '5%', sm: '10%', md: '12%' },
                  left: { xs: '0%', sm: '5%', md: '8%' }, // Changed left to right offset on mobile for balanced visual alignment
                  bgcolor: '#F6D9E8',
                  color: '#0F172A',
                  fontSize: { xs: 10, sm: 12, md: 14 },
                  fontWeight: 600,
                  px: { xs: 1.5, sm: 2, md: 2.5 },
                  py: { xs: 0.8, sm: 1.2, md: 1.5 },
                  borderRadius: 2,
                  textAlign: 'center',
                  boxShadow: '0 4px 12px rgba(0,0,0,0.08)',
                  zIndex: 2,
                  whiteSpace: 'nowrap',
                  opacity: 0.85,
                }}
              >
                Dedicated <br />{' '}
                <span style={{ fontWeight: 'normal' }}>
                  {' '}
                  English and Spanish
                </span>{' '}
                support
              </Box>
            </Box>
          </Stack>
        </Container>
      </Box>
      <Grid
        container
        sx={{
          backgroundColor: '#fff',
          mx: '0 !important',
          width: '100% !important',
        }}
        spacing={2}
        m={0}
        component="section"
        aria-labelledby="side-by-side"
      >
        <Container maxWidth="lg" sx={{ mb: 5 }}>
          <Grid
            container
            direction="row"
            justifyContent="center"
            alignItems="center"
            spacing={2}
            m={2}
            mt={5}
            pb={0}
            className="MuiGrid-root-width"
          >
            <Grid size={12}>
              <Typography
                variant="h2"
                sx={{
                  fontWeight: 600,

                  fontSize: {
                    xs: 20,
                    sm: 28,
                    md: 32,
                    lg: 38,
                  },
                  lineHeight: 1.3,
                  mb: 2,
                  textAlign: 'center',
                  scrollMarginTop: 88,
                }}
                id="compare"
              >
                Side by Side Comparison
              </Typography>
              <Typography
                variant="body1"
                sx={{
                  fontSize: {
                    xs: 16,
                    sm: 18,
                    md: 18,
                    lg: 20,
                    xl: 22,
                  },
                  fontWeight: 400,
                  color: '#333333',
                  mb: 3,
                  textAlign: 'center',
                }}
              >
                Compare TaxZerone and SimpleTruckTax across user experience,{' '}
                <Hidden smDown>
                  {' '}
                  <br />{' '}
                </Hidden>
                filing features, support, and overall convenience.
              </Typography>

              <Typography
                variant="h3"
                sx={{
                  fontSize: { md: 20, sm: 18, xs: 16 },
                  fontWeight: 600,
                  mb: 0.5,
                  textAlign: 'left !important',
                }}
              >
                Design & User Experience
              </Typography>
              <Typography variant="body1" sx={{ mb: 2 }}>
                How each platform feels to actually sit down and file with.
              </Typography>
              <TableContainer
                sx={{
                  // border: '1px solid #e2e8f0',
                  overflowX: {
                    xs: 'auto',
                    md: 'unset',
                  },
                  // background: '#ffffff',
                  // boxShadow: '0 8px 40px rgba(0, 0, 0, 0.2)',
                  mx: 'auto',
                  width: '100%',
                  // borderRadius: '12px',
                  overflow: 'hidden',
                  mb: 3,
                }}
              >
                <Box sx={{}}>
                  <Table
                    sx={{
                      minWidth: 600,
                      borderCollapse: 'collapse',
                      width: '100%',
                      borderSpacing: 0,
                      '& tbody tr:first-of-type td': {
                        borderTop: '2px solid #213e99',
                      },
                      '& tbody tr:last-of-type td': {
                        bborderBottom: '1px solid #ccc',
                      },
                      '& tbody tr td': { verticalAlign: 'middle' },
                    }}
                  >
                    <TableHead sx={{}}>
                      <TableRow sx={{}}>
                        <TableCell
                          sx={{
                            textAlign: 'left',
                            width: 300,
                            fontWeight: 600,
                            fontSize: 16,

                            color: '#333',
                            backgroundColor: '#f7f9f9 !important',
                            borderBottom: '2px solid #213e99',
                            borderLeft: '1px solid #ccc ',
                            borderTop: '1px solid #ccc',
                          }}
                        >
                          TaxZerone
                        </TableCell>
                        <TableCell
                          sx={{
                            color: '#333',

                            backgroundColor: '#e1f4fb !important',
                            borderBottom: 'none',
                            fontWeight: 500,
                            fontSize: { xs: 12, sm: 14, md: 16 },
                            width: 300,
                            textAlign: 'center',
                            borderTop: '1px solid #ccc',
                          }}
                        >
                          Experience Factor
                        </TableCell>

                        <TableCell
                          sx={{
                            color: '#333',

                            borderBottom: 'none',
                            textAlign: 'right',
                            width: 300,
                            borderRight: '1px solid #ccc',
                            backgroundColor: '#f7f9f9 !important',
                            borderTop: '1px solid #ccc',
                          }}
                        >
                          <Typography
                            component="span"
                            sx={{
                              fontSize: { xs: 12, sm: 14, md: 16 },
                              fontWeight: 600,
                              whiteSpace: 'nowrap',
                              color: '#333',
                            }}
                          >
                            SimpleTruckTax
                          </Typography>
                        </TableCell>
                      </TableRow>
                    </TableHead>

                    <TableBody
                      sx={{
                        borderLeft: '1px solid #ccc',
                        borderRight: '1px solid #ccc',
                        // borderBottom: '1px solid #ccc',
                        // borderRadius: '42px !important',
                        overflow: 'hidden',
                      }}
                    >
                      <TableRow
                        sx={{
                          // borderTopRightRadius: 4,
                          backgroundColor: '#f5f5f5',
                        }}
                      >
                        <TableCell
                          sx={{
                            fontWeight: 500,
                            // borderTop: ' 1px solid #ccc !important',
                            // borderTopLeftRadius: '12px',
                          }}
                        >
                          <Box
                            component="span"
                            sx={{
                              width: 22,
                              height: 22,
                              borderRadius: '50%',
                              backgroundColor: '#e7f7ef',
                              border: '1px solid #bee9d1',
                              display: 'inline-flex',
                              alignItems: 'center',
                              justifyContent: 'center',
                              flexShrink: 0,
                            }}
                          >
                            <Box
                              component="span"
                              sx={{
                                color: '#16A34A',
                                fontSize: 14,
                                fontWeight: 600,
                                lineHeight: 1,
                              }}
                            >
                              ✓
                            </Box>
                          </Box>
                          &nbsp; Yes (Clean, intuitive dashboard)
                        </TableCell>
                        <TableCell
                          sx={{
                            textAlign: 'center !important',
                            fontWeight: '600 !important',
                            backgroundColor: '#e1f4fb !important',
                          }}
                        >
                          Modern UI{' '}
                        </TableCell>
                        <TableCell sx={{ textAlign: 'right' }}>
                          Yes (Mobile-friendly layout) &nbsp;
                          <Box
                            component="span"
                            sx={{
                              width: 22,
                              height: 22,
                              borderRadius: '50%',
                              backgroundColor: '#FCEEEF',
                              border: '1px solid #bee9d1',

                              display: 'inline-flex',
                              alignItems: 'center',
                              justifyContent: 'center',
                              flexShrink: 0,
                            }}
                          >
                            <Box
                              component="span"
                              sx={{
                                color: '#16A34A',
                                fontSize: 14,
                                fontWeight: 600,
                                lineHeight: 1,
                              }}
                            >
                              ✓
                            </Box>
                          </Box>
                        </TableCell>
                      </TableRow>
                      <TableRow>
                        <TableCell
                          sx={{
                            // borderLeft: '2px solid #213e99',
                            // borderRight: '2px solid #213e99',
                            fontWeight: 500,
                          }}
                        >
                          <Box
                            component="span"
                            sx={{
                              width: 22,
                              height: 22,
                              borderRadius: '50%',
                              backgroundColor: '#e7f7ef',
                              border: '1px solid #bee9d1',

                              display: 'inline-flex',
                              alignItems: 'center',
                              justifyContent: 'center',
                              flexShrink: 0,
                            }}
                          >
                            <Box
                              component="span"
                              sx={{
                                color: '#16A34A',
                                fontSize: 14,
                                fontWeight: 600,
                                lineHeight: 1,
                              }}
                            >
                              ✓
                            </Box>
                          </Box>
                          &nbsp; Yes (Step-by-step wizard)
                        </TableCell>
                        <TableCell
                          sx={{
                            textAlign: 'center !important',
                            fontWeight: '600 !important',
                            backgroundColor: '#e1f4fb !important',
                          }}
                        >
                          Guided Filing Flow
                        </TableCell>
                        <TableCell sx={{ textAlign: 'right' }}>
                          Yes (Linear data entry) &nbsp;
                          <Box
                            component="span"
                            sx={{
                              width: 22,
                              height: 22,
                              borderRadius: '50%',
                              backgroundColor: '#e7f7ef',
                              border: '1px solid #bee9d1',

                              display: 'inline-flex',
                              alignItems: 'center',
                              justifyContent: 'center',
                              flexShrink: 0,
                            }}
                          >
                            <Box
                              component="span"
                              sx={{
                                color: '#16A34A',
                                fontSize: 14,
                                fontWeight: 600,
                                lineHeight: 1,
                              }}
                            >
                              ✓
                            </Box>
                          </Box>
                        </TableCell>
                      </TableRow>

                      <TableRow sx={{ backgroundColor: '#f5f5f5' }}>
                        <TableCell
                          sx={{
                            // borderLeft: '2px solid #213e99',
                            // borderRight: '2px solid #213e99',
                            fontWeight: 500,
                          }}
                        >
                          <Box
                            component="span"
                            sx={{
                              width: 22,
                              height: 22,
                              borderRadius: '50%',
                              backgroundColor: '#e7f7ef',
                              border: '1px solid #bee9d1',

                              display: 'inline-flex',
                              alignItems: 'center',
                              justifyContent: 'center',
                              flexShrink: 0,
                            }}
                          >
                            <Box
                              component="span"
                              sx={{
                                color: '#16A34A',
                                fontSize: 14,
                                fontWeight: 600,
                                lineHeight: 1,
                              }}
                            >
                              ✓
                            </Box>
                          </Box>
                          &nbsp; Available (Tooltips on boxes)
                        </TableCell>
                        <TableCell
                          sx={{
                            textAlign: 'center !important',
                            fontWeight: '600 !important',
                            backgroundColor: '#e1f4fb !important',
                          }}
                        >
                          Inline Help Text
                          <br style={{ marginBottom: 3 }} />
                          <Box
                            component="span"
                            sx={{
                              backgroundColor: '#ECEAFB',
                              color: '#332C74',
                              border: '1px solid #D9D5F5',
                              fontWeight: 600,
                              fontSize: 11,
                              px: 1,
                              py: 0.2,
                              borderRadius: 4,
                            }}
                          >
                            ★ Only TaxZerone
                          </Box>
                        </TableCell>
                        <TableCell sx={{ textAlign: 'right' }}>
                          Not Available (Relies on chat/FAQs) &nbsp;
                          <Box
                            component="span"
                            sx={{
                              width: 22,
                              height: 22,
                              borderRadius: '50%',
                              backgroundColor: '#FCEEEF',
                              border: '1px solid #F2CBCF',

                              display: 'inline-flex',
                              alignItems: 'center',
                              justifyContent: 'center',
                              flexShrink: 0,
                            }}
                          >
                            <Box
                              component="span"
                              sx={{
                                color: '#C63C4A',
                                fontSize: 14,
                                fontWeight: 600,
                                lineHeight: 1,
                              }}
                            >
                              x
                            </Box>
                          </Box>
                        </TableCell>
                      </TableRow>

                      <TableRow>
                        <TableCell
                          sx={{
                            fontWeight: 500,
                            textAlign: 'left',
                            borderBottom: '1px solid #ccc',
                          }}
                        >
                          <Box
                            component="span"
                            sx={{
                              width: 22,
                              height: 22,
                              borderRadius: '50%',
                              backgroundColor: '#e7f7ef',
                              border: '1px solid #bee9d1',

                              display: 'inline-flex',
                              alignItems: 'center',
                              justifyContent: 'center',
                              flexShrink: 0,
                            }}
                          >
                            <Box
                              component="span"
                              sx={{
                                color: '#16A34A',
                                fontSize: 14,
                                fontWeight: 600,
                                lineHeight: 1,
                              }}
                            >
                              ✓
                            </Box>
                          </Box>
                          &nbsp; Yes (Auto-saves EIN/details)
                        </TableCell>
                        <TableCell
                          sx={{
                            textAlign: 'center !important',
                            fontWeight: '600 !important',
                            backgroundColor: '#e1f4fb !important',
                            borderBottom: '1px solid #ccc',
                          }}
                        >
                          Saved Business Profiles
                        </TableCell>
                        <TableCell
                          sx={{
                            textAlign: 'right',
                            borderBottom: '1px solid #ccc',
                          }}
                        >
                          Yes (Reusable fleet profiles) &nbsp;
                          <Box
                            component="span"
                            sx={{
                              width: 22,
                              height: 22,
                              borderRadius: '50%',
                              backgroundColor: '#e7f7ef',
                              border: '1px solid #bee9d1',

                              display: 'inline-flex',
                              alignItems: 'center',
                              justifyContent: 'center',
                              flexShrink: 0,
                            }}
                          >
                            <Box
                              component="span"
                              sx={{
                                color: '#16A34A',
                                fontSize: 14,
                                fontWeight: 600,
                                lineHeight: 1,
                              }}
                            >
                              ✓
                            </Box>
                          </Box>
                        </TableCell>
                      </TableRow>
                    </TableBody>
                  </Table>
                </Box>
              </TableContainer>
              <Typography
                variant="h3"
                sx={{
                  fontSize: { md: 20, sm: 18, xs: 16 },
                  fontWeight: 600,
                  mb: 0.5,
                  textAlign: 'left !important',
                }}
              >
                Filing Features
              </Typography>
              <Typography variant="body1" sx={{ mb: 2 }}>
                What's actually supported once you get into the return itself.
              </Typography>
              <TableContainer
                sx={{
                  // border: '1px solid #e2e8f0',
                  overflowX: {
                    xs: 'auto',
                    md: 'unset',
                  },
                  background: '#ffffff',
                  // boxShadow: '0 8px 40px rgba(0, 0, 0, 0.2)',
                  mx: 'auto',
                  width: '100%',
                  // borderRadius: '12px',
                  overflow: 'hidden',
                  mb: 3,
                }}
              >
                <Box sx={{ minWidth: '840px' }}>
                  <Table
                    sx={{
                      minWidth: 600,
                      borderCollapse: 'collapse',
                      width: '100%',
                      borderSpacing: 0,
                      '& tbody tr:first-of-type td': {
                        borderTop: '2px solid #213e99',
                      },
                      '& tbody tr:last-of-type td': {
                        borderBottom: '1px solid #ccc',
                      },
                    }}
                  >
                    <TableHead>
                      <TableRow>
                        <TableCell
                          sx={{
                            textAlign: 'left',
                            width: 300,
                            fontWeight: 600,

                            fontSize: 16,
                            color: '#333',
                            backgroundColor: '#f7f9f9 !important',
                            // borderBottom: '2px solid #213e99',
                            borderLeft: '1px solid #ccc ',
                            borderTop: '1px solid #ccc',
                          }}
                        >
                          TaxZerone
                        </TableCell>
                        <TableCell
                          sx={{
                            backgroundColor: '#e1f4fb !important',
                            borderTop: '1px solid #ccc',
                            color: '#333',
                            borderBottom: 'none',
                            fontWeight: 500,
                            fontSize: { xs: 12, sm: 14, md: 16 },
                            width: 300,
                            textAlign: 'center',
                          }}
                        >
                          Feature
                        </TableCell>

                        <TableCell
                          sx={{
                            color: '#333',

                            borderBottom: 'none',
                            textAlign: 'right',
                            width: 300,
                            borderRight: '1px solid #ccc',
                            backgroundColor: '#f7f9f9 !important',
                            borderTop: '1px solid #ccc',
                          }}
                        >
                          <Typography
                            component="span"
                            sx={{
                              fontSize: { xs: 12, sm: 14, md: 16 },
                              fontWeight: 600,
                              whiteSpace: 'nowrap',
                              // color: '#333',
                            }}
                          >
                            SimpleTruckTax
                          </Typography>
                        </TableCell>
                      </TableRow>
                    </TableHead>

                    <TableBody
                      sx={{
                        borderLeft: '1px solid #ccc',
                        borderRight: '1px solid #ccc',
                        // borderBottom: '1px solid #ccc',
                        // borderRadius: '12px !important',
                        overflow: 'hidden',
                      }}
                    >
                      <TableRow
                        sx={{
                          // borderTopRightRadius: 3,
                          backgroundColor: '#f5f5f5',
                        }}
                      >
                        <TableCell
                          sx={{
                            fontWeight: 500,
                            // borderTop: ' 1px solid #ccc !important',
                          }}
                        >
                          <Box
                            component="span"
                            sx={{
                              width: 22,
                              height: 22,
                              borderRadius: '50%',
                              backgroundColor: '#e7f7ef',
                              border: '1px solid #bee9d1',
                              display: 'inline-flex',
                              alignItems: 'center',
                              justifyContent: 'center',
                              flexShrink: 0,
                            }}
                          >
                            <Box
                              component="span"
                              sx={{
                                color: '#16A34A',
                                fontSize: 14,
                                fontWeight: 600,
                                lineHeight: 1,
                              }}
                            >
                              ✓
                            </Box>
                          </Box>
                          &nbsp; Taxable
                        </TableCell>
                        <TableCell
                          rowSpan={7}
                          sx={{
                            textAlign: 'center !important',
                            fontWeight: '600 !important',
                            backgroundColor: '#e1f4fb !important',
                          }}
                        >
                          Supported Filing{' '}
                        </TableCell>
                        <TableCell sx={{ textAlign: 'right' }}>
                          Taxable &nbsp;
                          <Box
                            component="span"
                            sx={{
                              width: 22,
                              height: 22,
                              borderRadius: '50%',
                              backgroundColor: '#e7f7ef',
                              border: '1px solid #bee9d1',

                              display: 'inline-flex',
                              alignItems: 'center',
                              justifyContent: 'center',
                              flexShrink: 0,
                            }}
                          >
                            <Box
                              component="span"
                              sx={{
                                color: '#16A34A',
                                fontSize: 14,
                                fontWeight: 600,
                                lineHeight: 1,
                              }}
                            >
                              ✓
                            </Box>
                          </Box>
                        </TableCell>
                      </TableRow>

                      <TableRow sx={{ backgroundColor: '#f5f5f5' }}>
                        <TableCell
                          sx={{
                            fontWeight: 500,
                          }}
                        >
                          <Box
                            component="span"
                            sx={{
                              width: 22,
                              height: 22,
                              borderRadius: '50%',
                              backgroundColor: '#e7f7ef',
                              border: '1px solid #bee9d1',

                              display: 'inline-flex',
                              alignItems: 'center',
                              justifyContent: 'center',
                              flexShrink: 0,
                            }}
                          >
                            <Box
                              component="span"
                              sx={{
                                color: '#16A34A',
                                fontSize: 14,
                                fontWeight: 600,
                                lineHeight: 1,
                              }}
                            >
                              ✓
                            </Box>
                          </Box>
                          &nbsp; Suspended
                        </TableCell>
                        <TableCell sx={{ textAlign: 'right' }}>
                          Suspended &nbsp;
                          <Box
                            component="span"
                            sx={{
                              width: 22,
                              height: 22,
                              borderRadius: '50%',
                              backgroundColor: '#e7f7ef',
                              border: '1px solid #bee9d1',

                              display: 'inline-flex',
                              alignItems: 'center',
                              justifyContent: 'center',
                              flexShrink: 0,
                            }}
                          >
                            <Box
                              component="span"
                              sx={{
                                color: '#16A34A',
                                fontSize: 14,
                                fontWeight: 600,
                                lineHeight: 1,
                              }}
                            >
                              ✓
                            </Box>
                          </Box>
                        </TableCell>
                      </TableRow>

                      <TableRow sx={{ backgroundColor: '#f5f5f5' }}>
                        <TableCell
                          sx={{
                            fontWeight: 500,
                          }}
                        >
                          <Box
                            component="span"
                            sx={{
                              width: 22,
                              height: 22,
                              borderRadius: '50%',
                              backgroundColor: '#e7f7ef',
                              border: '1px solid #bee9d1',

                              display: 'inline-flex',
                              alignItems: 'center',
                              justifyContent: 'center',
                              flexShrink: 0,
                            }}
                          >
                            <Box
                              component="span"
                              sx={{
                                color: '#16A34A',
                                fontSize: 14,
                                fontWeight: 600,
                                lineHeight: 1,
                              }}
                            >
                              ✓
                            </Box>
                          </Box>{' '}
                          &nbsp; Amendments
                        </TableCell>
                        <TableCell sx={{ textAlign: 'right' }}>
                          Amendments &nbsp;
                          <Box
                            component="span"
                            sx={{
                              width: 22,
                              height: 22,
                              borderRadius: '50%',
                              backgroundColor: '#e7f7ef',
                              border: '1px solid #bee9d1',

                              display: 'inline-flex',
                              alignItems: 'center',
                              justifyContent: 'center',
                              flexShrink: 0,
                            }}
                          >
                            <Box
                              component="span"
                              sx={{
                                color: '#16A34A',
                                fontSize: 14,
                                fontWeight: 600,
                                lineHeight: 1,
                              }}
                            >
                              ✓
                            </Box>
                          </Box>
                        </TableCell>
                      </TableRow>

                      <TableRow sx={{ backgroundColor: '#f5f5f5' }}>
                        <TableCell
                          sx={{
                            fontWeight: 500,
                          }}
                        >
                          <Box
                            component="span"
                            sx={{
                              width: 22,
                              height: 22,
                              borderRadius: '50%',
                              backgroundColor: '#e7f7ef',
                              border: '1px solid #bee9d1',

                              display: 'inline-flex',
                              alignItems: 'center',
                              justifyContent: 'center',
                              flexShrink: 0,
                            }}
                          >
                            <Box
                              component="span"
                              sx={{
                                color: '#16A34A',
                                fontSize: 14,
                                fontWeight: 600,
                                lineHeight: 1,
                              }}
                            >
                              ✓
                            </Box>
                          </Box>{' '}
                          &nbsp; Free VIN correction
                        </TableCell>
                        <TableCell sx={{ textAlign: 'right' }}>
                          Free VIN correction &nbsp;
                          <Box
                            component="span"
                            sx={{
                              width: 22,
                              height: 22,
                              borderRadius: '50%',
                              backgroundColor: '#e7f7ef',
                              border: '1px solid #bee9d1',

                              display: 'inline-flex',
                              alignItems: 'center',
                              justifyContent: 'center',
                              flexShrink: 0,
                            }}
                          >
                            <Box
                              component="span"
                              sx={{
                                color: '#16A34A',
                                fontSize: 14,
                                fontWeight: 600,
                                lineHeight: 1,
                              }}
                            >
                              ✓
                            </Box>
                          </Box>{' '}
                        </TableCell>
                      </TableRow>
                      <TableRow sx={{ backgroundColor: '#f5f5f5' }}>
                        <TableCell
                          sx={{
                            fontWeight: 500,
                          }}
                        >
                          <Box
                            component="span"
                            sx={{
                              width: 22,
                              height: 22,
                              borderRadius: '50%',
                              backgroundColor: '#e7f7ef',
                              border: '1px solid #bee9d1',

                              display: 'inline-flex',
                              alignItems: 'center',
                              justifyContent: 'center',
                              flexShrink: 0,
                            }}
                          >
                            <Box
                              component="span"
                              sx={{
                                color: '#16A34A',
                                fontSize: 14,
                                fontWeight: 600,
                                lineHeight: 1,
                              }}
                            >
                              ✓
                            </Box>
                          </Box>
                          &nbsp;Free Retransmission
                        </TableCell>
                        <TableCell sx={{ textAlign: 'right' }}>
                          Free Retransmission&nbsp;
                          <Box
                            component="span"
                            sx={{
                              width: 22,
                              height: 22,
                              borderRadius: '50%',
                              backgroundColor: '#e7f7ef',
                              border: '1px solid #bee9d1',

                              display: 'inline-flex',
                              alignItems: 'center',
                              justifyContent: 'center',
                              flexShrink: 0,
                            }}
                          >
                            <Box
                              component="span"
                              sx={{
                                color: '#16A34A',
                                fontSize: 14,
                                fontWeight: 600,
                                lineHeight: 1,
                              }}
                            >
                              ✓
                            </Box>
                          </Box>{' '}
                        </TableCell>
                      </TableRow>
                      <TableRow sx={{ backgroundColor: '#f5f5f5' }}>
                        <TableCell
                          sx={{
                            fontWeight: 500,
                          }}
                        >
                          <Box
                            component="span"
                            sx={{
                              width: 22,
                              height: 22,
                              borderRadius: '50%',
                              backgroundColor: '#e7f7ef',
                              border: '1px solid #bee9d1',

                              display: 'inline-flex',
                              alignItems: 'center',
                              justifyContent: 'center',
                              flexShrink: 0,
                            }}
                          >
                            <Box
                              component="span"
                              sx={{
                                color: '#16A34A',
                                fontSize: 14,
                                fontWeight: 600,
                                lineHeight: 1,
                              }}
                            >
                              ✓
                            </Box>
                          </Box>{' '}
                          &nbsp; Prior-year filings
                        </TableCell>
                        <TableCell sx={{ textAlign: 'right' }}>
                          Prior-year filings &nbsp;{' '}
                          <Box
                            component="span"
                            sx={{
                              width: 22,
                              height: 22,
                              borderRadius: '50%',
                              backgroundColor: '#e7f7ef',
                              border: '1px solid #bee9d1',

                              display: 'inline-flex',
                              alignItems: 'center',
                              justifyContent: 'center',
                              flexShrink: 0,
                            }}
                          >
                            <Box
                              component="span"
                              sx={{
                                color: '#16A34A',
                                fontSize: 14,
                                fontWeight: 600,
                                lineHeight: 1,
                              }}
                            >
                              ✓
                            </Box>
                          </Box>{' '}
                        </TableCell>
                      </TableRow>
                      <TableRow sx={{ backgroundColor: '#f5f5f5' }}>
                        <TableCell
                          sx={{
                            fontWeight: 500,
                          }}
                        >
                          <Box
                            component="span"
                            sx={{
                              width: 22,
                              height: 22,
                              borderRadius: '50%',
                              backgroundColor: '#e7f7ef',
                              border: '1px solid #bee9d1',

                              display: 'inline-flex',
                              alignItems: 'center',
                              justifyContent: 'center',
                              flexShrink: 0,
                            }}
                          >
                            <Box
                              component="span"
                              sx={{
                                color: '#16A34A',
                                fontSize: 14,
                                fontWeight: 600,
                                lineHeight: 1,
                              }}
                            >
                              ✓
                            </Box>
                          </Box>
                          &nbsp; Form 8849
                        </TableCell>
                        <TableCell sx={{ textAlign: 'right' }}>
                          Form 8849 &nbsp;
                          <Box
                            component="span"
                            sx={{
                              width: 22,
                              height: 22,
                              borderRadius: '50%',
                              backgroundColor: '#e7f7ef',
                              border: '1px solid #bee9d1',

                              display: 'inline-flex',
                              alignItems: 'center',
                              justifyContent: 'center',
                              flexShrink: 0,
                            }}
                          >
                            <Box
                              component="span"
                              sx={{
                                color: '#16A34A',
                                fontSize: 14,
                                fontWeight: 600,
                                lineHeight: 1,
                              }}
                            >
                              ✓
                            </Box>
                          </Box>{' '}
                        </TableCell>
                      </TableRow>
                      <TableRow sx={{}}>
                        <TableCell
                          sx={{
                            fontWeight: 500,
                          }}
                        >
                          <Box
                            component="span"
                            sx={{
                              width: 22,
                              height: 22,
                              borderRadius: '50%',
                              backgroundColor: '#e7f7ef',
                              border: '1px solid #bee9d1',

                              display: 'inline-flex',
                              alignItems: 'center',
                              justifyContent: 'center',
                              flexShrink: 0,
                            }}
                          >
                            <Box
                              component="span"
                              sx={{
                                color: '#16A34A',
                                fontSize: 14,
                                fontWeight: 600,
                                lineHeight: 1,
                              }}
                            >
                              ✓
                            </Box>
                          </Box>
                          &nbsp; CSV/Excel bulk upload
                          <Box sx={{ display: 'flex', gap: 0.2, mt: 2 }}>
                            <Box
                              component="span"
                              sx={{
                                width: 22,
                                height: 22,
                                borderRadius: '50%',
                                backgroundColor: '#e7f7ef',
                                border: '1px solid #bee9d1',

                                display: 'inline-flex',
                                alignItems: 'center',
                                justifyContent: 'center',
                                flexShrink: 0,
                              }}
                            >
                              <Box
                                component="span"
                                sx={{
                                  color: '#16A34A',
                                  fontSize: 14,
                                  fontWeight: 600,
                                  lineHeight: 1,
                                }}
                              >
                                ✓
                              </Box>
                            </Box>
                            &nbsp;{' '}
                            <Box>
                              {' '}
                              Other file formats supported via secure file
                              upload
                            </Box>
                          </Box>
                        </TableCell>
                        <TableCell
                          sx={{
                            textAlign: 'center !important',
                            fontWeight: '600 !important',
                            backgroundColor: '#e1f4fb !important',
                          }}
                        >
                          Bulk Upload{' '}
                        </TableCell>
                        <TableCell sx={{ textAlign: 'right' }}>
                          CSV/Excel bulk upload &nbsp;
                          <Box
                            component="span"
                            sx={{
                              width: 22,
                              height: 22,
                              borderRadius: '50%',
                              backgroundColor: '#e7f7ef',
                              border: '1px solid #bee9d1',

                              display: 'inline-flex',
                              alignItems: 'center',
                              justifyContent: 'center',
                              flexShrink: 0,
                            }}
                          >
                            <Box
                              component="span"
                              sx={{
                                color: '#16A34A',
                                fontSize: 14,
                                fontWeight: 600,
                                lineHeight: 1,
                              }}
                            >
                              ✓
                            </Box>
                          </Box>{' '}
                        </TableCell>
                      </TableRow>

                      <TableRow
                        sx={{
                          backgroundColor: '#f5f5f5',
                        }}
                      >
                        <TableCell
                          sx={{
                            fontWeight: 500,
                          }}
                        >
                          <Box
                            component="span"
                            sx={{
                              width: 22,
                              height: 22,
                              borderRadius: '50%',
                              backgroundColor: '#e7f7ef',
                              border: '1px solid #bee9d1',

                              display: 'inline-flex',
                              alignItems: 'center',
                              justifyContent: 'center',
                              flexShrink: 0,
                            }}
                          >
                            <Box
                              component="span"
                              sx={{
                                color: '#16A34A',
                                fontSize: 14,
                                fontWeight: 600,
                                lineHeight: 1,
                              }}
                            >
                              ✓
                            </Box>
                          </Box>
                          &nbsp; File multiple vehicles at once
                        </TableCell>
                        <TableCell
                          sx={{
                            textAlign: 'center !important',
                            fontWeight: '600 !important',
                            backgroundColor: '#e1f4fb !important',
                          }}
                        >
                          Bulk Filing
                        </TableCell>
                        <TableCell sx={{ textAlign: 'right' }}>
                          Available &nbsp;
                          <Box
                            component="span"
                            sx={{
                              width: 22,
                              height: 22,
                              borderRadius: '50%',
                              backgroundColor: '#e7f7ef',
                              border: '1px solid #bee9d1',

                              display: 'inline-flex',
                              alignItems: 'center',
                              justifyContent: 'center',
                              flexShrink: 0,
                            }}
                          >
                            <Box
                              component="span"
                              sx={{
                                color: '#16A34A',
                                fontSize: 14,
                                fontWeight: 600,
                                lineHeight: 1,
                              }}
                            >
                              ✓
                            </Box>
                          </Box>{' '}
                        </TableCell>
                      </TableRow>

                      <TableRow>
                        <TableCell
                          sx={{
                            fontWeight: 500,
                            display: 'flex',
                            gap: 0.2,
                            borderBottom: 'none',
                          }}
                        >
                          <Box
                            component="span"
                            sx={{
                              width: 22,
                              height: 22,
                              borderRadius: '50%',
                              backgroundColor: '#e7f7ef',
                              border: '1px solid #bee9d1',

                              display: 'inline-flex',
                              alignItems: 'center',
                              justifyContent: 'center',
                              flexShrink: 0,
                            }}
                          >
                            <Box
                              component="span"
                              sx={{
                                color: '#16A34A',
                                fontSize: 14,
                                fontWeight: 600,
                                lineHeight: 1,
                              }}
                            >
                              ✓
                            </Box>
                          </Box>
                          &nbsp;
                          <Box>
                            Autofill your return using Prior-Year Schedule 1
                          </Box>
                        </TableCell>
                        <TableCell
                          sx={{
                            textAlign: 'center !important',
                            fontWeight: '600 !important',
                            backgroundColor: '#e1f4fb !important',
                          }}
                        >
                          Upload Last Year’s Schedule 1
                          <br style={{ marginBottom: 3 }} />
                          <Box
                            component="span"
                            sx={{
                              backgroundColor: '#ECEAFB',
                              color: '#332C74',
                              border: '1px solid #D9D5F5',
                              fontWeight: 600,
                              fontSize: 11,
                              px: 1,
                              py: 0.2,
                              borderRadius: 4,
                            }}
                          >
                            ★ Only TaxZerone
                          </Box>
                        </TableCell>
                        <TableCell sx={{ textAlign: 'right' }}>
                          Not available &nbsp;
                          <Box
                            component="span"
                            sx={{
                              width: 22,
                              height: 22,
                              borderRadius: '50%',
                              backgroundColor: '#FCEEEF',
                              border: '1px solid #F2CBCF',

                              display: 'inline-flex',
                              alignItems: 'center',
                              justifyContent: 'center',
                              flexShrink: 0,
                            }}
                          >
                            <Box
                              component="span"
                              sx={{
                                color: '#C63C4A',
                                fontSize: 14,
                                fontWeight: 600,
                                lineHeight: 1,
                              }}
                            >
                              x
                            </Box>
                          </Box>
                        </TableCell>
                      </TableRow>

                      <TableRow
                        sx={{
                          backgroundColor: '#f5f5f5',
                        }}
                      >
                        <TableCell
                          sx={{
                            fontWeight: 500,
                          }}
                        >
                          <Box
                            component="span"
                            sx={{
                              width: 22,
                              height: 22,
                              borderRadius: '50%',
                              backgroundColor: '#e7f7ef',
                              border: '1px solid #bee9d1',

                              display: 'inline-flex',
                              alignItems: 'center',
                              justifyContent: 'center',
                              flexShrink: 0,
                            }}
                          >
                            <Box
                              component="span"
                              sx={{
                                color: '#16A34A',
                                fontSize: 14,
                                fontWeight: 600,
                                lineHeight: 1,
                              }}
                            >
                              ✓
                            </Box>
                          </Box>
                          &nbsp; Available
                        </TableCell>
                        <TableCell
                          sx={{
                            textAlign: 'center !important',
                            fontWeight: '600 !important',
                            backgroundColor: '#e1f4fb !important',
                          }}
                        >
                          Full-Service Filing <br />
                          <span style={{ fontWeight: 400, fontSize: 13 }}>
                            {' '}
                            (Phone, Email & Chat)
                          </span>
                          <br style={{ marginBottom: 5 }} />
                          <Box
                            component="span"
                            sx={{
                              backgroundColor: '#ECEAFB',
                              color: '#332C74',
                              border: '1px solid #D9D5F5',
                              fontWeight: 600,
                              fontSize: 11,
                              px: 1,
                              py: 0.2,
                              borderRadius: 4,
                            }}
                          >
                            ★ Only TaxZerone
                          </Box>
                        </TableCell>
                        <TableCell sx={{ textAlign: 'right' }}>
                          Not available &nbsp;
                          <Box
                            component="span"
                            sx={{
                              width: 22,
                              height: 22,
                              borderRadius: '50%',
                              backgroundColor: '#FCEEEF',
                              border: '1px solid #F2CBCF',

                              display: 'inline-flex',
                              alignItems: 'center',
                              justifyContent: 'center',
                              flexShrink: 0,
                            }}
                          >
                            <Box
                              component="span"
                              sx={{
                                color: '#C63C4A',
                                fontSize: 14,
                                fontWeight: 600,
                                lineHeight: 1,
                              }}
                            >
                              x
                            </Box>
                          </Box>
                        </TableCell>
                      </TableRow>
                      <TableRow sx={{}}>
                        <TableCell
                          sx={{
                            fontWeight: 500,
                          }}
                        >
                          <Box
                            component="span"
                            sx={{
                              width: 22,
                              height: 22,
                              borderRadius: '50%',
                              backgroundColor: '#e7f7ef',
                              border: '1px solid #bee9d1',

                              display: 'inline-flex',
                              alignItems: 'center',
                              justifyContent: 'center',
                              flexShrink: 0,
                            }}
                          >
                            <Box
                              component="span"
                              sx={{
                                color: '#16A34A',
                                fontSize: 14,
                                fontWeight: 600,
                                lineHeight: 1,
                              }}
                            >
                              ✓
                            </Box>
                          </Box>
                          &nbsp; In minutes
                        </TableCell>
                        <TableCell
                          sx={{
                            textAlign: 'center !important',
                            fontWeight: '600 !important',
                            backgroundColor: '#e1f4fb !important',
                          }}
                        >
                          IRS-Stamped Schedule 1 Delivery{' '}
                          <br style={{ marginBottom: 3 }} />
                          <Box
                            component="span"
                            sx={{
                              backgroundColor: '#FBF1DD',
                              color: '#8A5A00',
                              border: '1px solid #F1DDA9',
                              fontWeight: 600,
                              fontSize: 11,
                              px: 1,
                              py: 0.2,
                              borderRadius: 4,
                            }}
                          >
                            🗲 Faster
                          </Box>
                        </TableCell>
                        <TableCell sx={{ textAlign: 'right' }}>
                          After IRS acceptance &nbsp;
                          <Box
                            component="span"
                            sx={{
                              width: 22,
                              height: 22,
                              borderRadius: '50%',
                              backgroundColor: '#e7f7ef',
                              border: '1px solid #bee9d1',

                              display: 'inline-flex',
                              alignItems: 'center',
                              justifyContent: 'center',
                              flexShrink: 0,
                            }}
                          >
                            <Box
                              component="span"
                              sx={{
                                color: '#16A34A',
                                fontSize: 14,
                                fontWeight: 600,
                                lineHeight: 1,
                              }}
                            >
                              ✓
                            </Box>
                          </Box>
                        </TableCell>
                      </TableRow>
                      <TableRow
                        sx={{
                          backgroundColor: '#f5f5f5',
                        }}
                      >
                        <TableCell
                          sx={{
                            fontWeight: 500,
                          }}
                        >
                          <Box
                            component="span"
                            sx={{
                              width: 22,
                              height: 22,
                              borderRadius: '50%',
                              backgroundColor: '#e7f7ef',
                              border: '1px solid #bee9d1',

                              display: 'inline-flex',
                              alignItems: 'center',
                              justifyContent: 'center',
                              flexShrink: 0,
                            }}
                          >
                            <Box
                              component="span"
                              sx={{
                                color: '#16A34A',
                                fontSize: 14,
                                fontWeight: 600,
                                lineHeight: 1,
                              }}
                            >
                              ✓
                            </Box>
                          </Box>
                          &nbsp; Yes
                        </TableCell>
                        <TableCell
                          sx={{
                            textAlign: 'center !important',
                            fontWeight: '600 !important',
                            backgroundColor: '#e1f4fb !important',
                          }}
                        >
                          Real Time Filing Status{' '}
                        </TableCell>
                        <TableCell sx={{ textAlign: 'right' }}>
                          Yes&nbsp;{' '}
                          <Box
                            component="span"
                            sx={{
                              width: 22,
                              height: 22,
                              borderRadius: '50%',
                              backgroundColor: '#e7f7ef',
                              border: '1px solid #bee9d1',

                              display: 'inline-flex',
                              alignItems: 'center',
                              justifyContent: 'center',
                              flexShrink: 0,
                            }}
                          >
                            <Box
                              component="span"
                              sx={{
                                color: '#16A34A',
                                fontSize: 14,
                                fontWeight: 600,
                                lineHeight: 1,
                              }}
                            >
                              ✓
                            </Box>
                          </Box>
                        </TableCell>
                      </TableRow>
                      <TableRow>
                        <TableCell
                          sx={{
                            fontWeight: 500,
                          }}
                        >
                          <Box
                            component="span"
                            sx={{
                              width: 22,
                              height: 22,
                              borderRadius: '50%',
                              backgroundColor: '#e7f7ef',
                              border: '1px solid #bee9d1',

                              display: 'inline-flex',
                              alignItems: 'center',
                              justifyContent: 'center',
                              flexShrink: 0,
                            }}
                          >
                            <Box
                              component="span"
                              sx={{
                                color: '#16A34A',
                                fontSize: 14,
                                fontWeight: 600,
                                lineHeight: 1,
                              }}
                            >
                              ✓
                            </Box>
                          </Box>
                          &nbsp; 20% Referral Bonus
                        </TableCell>
                        <TableCell
                          sx={{
                            textAlign: 'center !important',
                            fontWeight: '600 !important',
                            backgroundColor: '#e1f4fb !important',
                          }}
                        >
                          Referral Rewards <br style={{ marginBottom: 3 }} />
                          <Box
                            component="span"
                            sx={{
                              backgroundColor: '#ECEAFB',
                              color: '#332C74',
                              border: '1px solid #D9D5F5',
                              fontWeight: 600,
                              fontSize: 11,
                              px: 1,
                              py: 0.2,
                              borderRadius: 4,
                            }}
                          >
                            ★ Only TaxZerone
                          </Box>
                        </TableCell>
                        <TableCell sx={{ textAlign: 'right' }}>
                          Not available &nbsp;
                          <Box
                            component="span"
                            sx={{
                              width: 22,
                              height: 22,
                              borderRadius: '50%',
                              backgroundColor: '#FCEEEF',
                              border: '1px solid #F2CBCF',

                              display: 'inline-flex',
                              alignItems: 'center',
                              justifyContent: 'center',
                              flexShrink: 0,
                            }}
                          >
                            <Box
                              component="span"
                              sx={{
                                color: '#C63C4A',
                                fontSize: 14,
                                fontWeight: 600,
                                lineHeight: 1,
                              }}
                            >
                              x
                            </Box>
                          </Box>
                        </TableCell>
                      </TableRow>
                      <TableRow
                        sx={{
                          backgroundColor: '#f5f5f5',
                        }}
                      >
                        <TableCell
                          sx={{
                            fontWeight: 500,
                          }}
                        >
                          <Box sx={{ display: 'flex', gap: 1.5 }}>
                            <Box
                              component="span"
                              sx={{
                                width: 22,
                                height: 22,
                                borderRadius: '50%',
                                backgroundColor: '#e7f7ef',
                                border: '1px solid #bee9d1',

                                display: 'inline-flex',
                                alignItems: 'center',
                                justifyContent: 'center',
                                flexShrink: 0,
                              }}
                            >
                              <Box
                                component="span"
                                sx={{
                                  color: '#16A34A',
                                  fontSize: 14,
                                  fontWeight: 600,
                                  lineHeight: 1,
                                }}
                              >
                                ✓
                              </Box>
                            </Box>
                            <Box>
                              Save 10% with prepaid credits which never expire.
                            </Box>
                          </Box>
                        </TableCell>
                        <TableCell
                          sx={{
                            textAlign: 'center !important',
                            fontWeight: '600 !important',
                            backgroundColor: '#e1f4fb !important',
                          }}
                        >
                          Prepaid Filing Credits{' '}
                        </TableCell>
                        <TableCell sx={{ textAlign: 'right' }}>
                          available&nbsp;
                          <Box
                            component="span"
                            sx={{
                              width: 22,
                              height: 22,
                              borderRadius: '50%',
                              backgroundColor: '#e7f7ef',
                              border: '1px solid #bee9d1',

                              display: 'inline-flex',
                              alignItems: 'center',
                              justifyContent: 'center',
                              flexShrink: 0,
                            }}
                          >
                            <Box
                              component="span"
                              sx={{
                                color: '#16A34A',
                                fontSize: 14,
                                fontWeight: 600,
                                lineHeight: 1,
                              }}
                            >
                              ✓
                            </Box>
                          </Box>
                        </TableCell>
                      </TableRow>
                      <TableRow sx={{}}>
                        <TableCell
                          sx={{
                            fontWeight: 500,
                          }}
                        >
                          <Box
                            component="span"
                            sx={{
                              width: 22,
                              height: 22,
                              borderRadius: '50%',
                              backgroundColor: '#e7f7ef',
                              border: '1px solid #bee9d1',

                              display: 'inline-flex',
                              alignItems: 'center',
                              justifyContent: 'center',
                              flexShrink: 0,
                            }}
                          >
                            <Box
                              component="span"
                              sx={{
                                color: '#16A34A',
                                fontSize: 14,
                                fontWeight: 600,
                                lineHeight: 1,
                              }}
                            >
                              ✓
                            </Box>
                          </Box>
                          &nbsp; Available on Google Play & iOS
                        </TableCell>
                        <TableCell
                          sx={{
                            textAlign: 'center !important',
                            fontWeight: '600 !important',
                            backgroundColor: '#e1f4fb !important',
                          }}
                        >
                          Mobile App{' '}
                        </TableCell>
                        <TableCell sx={{ textAlign: 'right' }}>
                          Available on Google Play only &nbsp;
                          <Box
                            component="span"
                            sx={{
                              width: 22,
                              height: 22,
                              borderRadius: '50%',
                              backgroundColor: '#e7f7ef',
                              border: '1px solid #bee9d1',

                              display: 'inline-flex',
                              alignItems: 'center',
                              justifyContent: 'center',
                              flexShrink: 0,
                            }}
                          >
                            <Box
                              component="span"
                              sx={{
                                color: '#16A34A',
                                fontSize: 14,
                                fontWeight: 600,
                                lineHeight: 1,
                              }}
                            >
                              ✓
                            </Box>
                          </Box>
                        </TableCell>
                      </TableRow>
                    </TableBody>
                  </Table>
                </Box>
              </TableContainer>
              <Typography
                variant="h3"
                sx={{
                  fontSize: { md: 20, sm: 18, xs: 16 },
                  fontWeight: 600,
                  mb: 0.5,
                  textAlign: 'left !important',
                }}
              >
                Unlimited Filing Pricing
              </Typography>
              <Typography variant="body1" sx={{ mb: 2 }}>
                How affordable the platform is for filing multiple returns.
              </Typography>
              <TableContainer
                sx={{
                  // border: '1px solid #e2e8f0',
                  overflowX: {
                    xs: 'auto',
                    md: 'unset',
                  },
                  background: '#ffffff',
                  // boxShadow: '0 8px 40px rgba(0, 0, 0, 0.2)',
                  mx: 'auto',
                  width: '100%',
                  // borderRadius: '12px',
                  overflow: 'hidden',
                  mb: 3,
                }}
              >
                <Box sx={{ minWidth: '840px' }}>
                  <Table
                    sx={{
                      minWidth: 600,
                      borderCollapse: 'collapse',
                      width: '100%',
                      borderSpacing: 0,
                      '& tbody tr:first-of-type td': {
                        borderTop: '2px solid #213e99',
                      },
                      '& tbody tr:last-of-type td': {
                        borderBottom: '1px solid #ccc',
                      },
                    }}
                  >
                    <TableHead>
                      <TableRow>
                        <TableCell
                          sx={{
                            textAlign: 'left',
                            width: 300,
                            fontWeight: 600,
                            fontSize: 16,
                            color: '#333',
                            backgroundColor: '#f7f9f9 !important',
                            borderBottom: '2px solid #213e99',
                            borderLeft: '1px solid #ccc ',
                            borderTop: '1px solid #ccc',
                          }}
                        >
                          TaxZerone
                        </TableCell>
                        <TableCell
                          sx={{
                            color: '#333',
                            backgroundColor: '#e1f4fb !important',
                            borderTop: '1px solid #ccc',
                            borderBottom: 'none',
                            fontWeight: 500,
                            fontSize: { xs: 12, sm: 14, md: 16 },
                            width: 300,
                            textAlign: 'center',
                          }}
                        >
                          Pricing
                        </TableCell>

                        <TableCell
                          sx={{
                            borderBottom: 'none',
                            textAlign: 'right',
                            width: 300,
                            backgroundColor: '#f7f9f9 !important',
                            color: '#333',
                            borderRight: '1px solid #ccc ',
                            borderTop: '1px solid #ccc',
                          }}
                        >
                          <Typography
                            component="span"
                            sx={{
                              fontSize: { xs: 12, sm: 14, md: 16 },
                              fontWeight: 600,
                              whiteSpace: 'nowrap',
                              // color: '#0f172a',
                            }}
                          >
                            SimpleTruckTax
                          </Typography>
                        </TableCell>
                      </TableRow>
                    </TableHead>

                    <TableBody
                      sx={{
                        borderLeft: '1px solid #ccc',
                        borderRight: '1px solid #ccc',
                        // borderBottom: '1px solid #ccc',
                        // borderTop: '1px solid #ccc',
                        // borderRadius: '12px !important',
                        overflow: 'hidden',
                      }}
                    >
                      <TableRow
                        sx={{
                          borderTopRightRadius: 3,
                          backgroundColor: '#f5f5f5',
                        }}
                      >
                        <TableCell
                          sx={{
                            fontWeight: 500,
                            borderTop: ' 1px solid #ccc !important',
                          }}
                        >
                          <Box sx={{ display: 'flex', gap: 1 }}>
                            <Box
                              component="span"
                              sx={{
                                width: 22,
                                height: 22,
                                borderRadius: '50%',
                                backgroundColor: '#e7f7ef',
                                border: '1px solid #bee9d1',

                                display: 'inline-flex',
                                alignItems: 'center',
                                justifyContent: 'center',
                                flexShrink: 0,
                              }}
                            >
                              <Box
                                component="span"
                                sx={{
                                  color: '#16A34A',
                                  fontSize: 14,
                                  fontWeight: 600,
                                  lineHeight: 1,
                                }}
                              >
                                ✓
                              </Box>
                            </Box>

                            <Box>
                              Available <br />(
                              <strong style={{ fontWeight: 700 }}>
                                {' '}
                                $179.99
                              </strong>
                              /yr for a single entity)
                            </Box>
                          </Box>
                        </TableCell>
                        <TableCell
                          sx={{
                            textAlign: 'center !important',
                            fontWeight: '600 !important',
                            backgroundColor: '#e1f4fb !important',
                          }}
                        >
                          Unlimited Form 2290 Filings
                          <br />
                          <Typography
                            component="div"
                            sx={{
                              backgroundColor: '#ECEAFB',
                              color: '#332C74',
                              border: '1px solid #D9D5F5',
                              fontWeight: 600,
                              fontSize: 11,
                              px: 1,
                              py: 0.2,
                              mt: 0.5,
                              borderRadius: 4,
                              display: 'inline-block',
                            }}
                          >
                            ★ Only TaxZerone
                          </Typography>
                        </TableCell>
                        <TableCell sx={{ textAlign: 'right' }}>
                          <Box
                            sx={{
                              display: 'flex',
                              gap: 1,
                              justifyContent: 'flex-end',
                            }}
                          >
                            <Box>Not available</Box>
                            <Box
                              component="span"
                              sx={{
                                width: 22,
                                height: 22,
                                borderRadius: '50%',
                                backgroundColor: '#FCEEEF',
                                border: '1px solid #F2CBCF',

                                display: 'inline-flex',
                                alignItems: 'center',
                                justifyContent: 'center',
                                flexShrink: 0,
                              }}
                            >
                              <Box
                                component="span"
                                sx={{
                                  color: '#C63C4A',
                                  fontSize: 14,
                                  fontWeight: 600,
                                  lineHeight: 1,
                                }}
                              >
                                x
                              </Box>
                            </Box>
                          </Box>
                        </TableCell>
                      </TableRow>

                      <TableRow>
                        <TableCell
                          sx={{
                            fontWeight: 500,
                          }}
                        >
                          <Box sx={{ display: 'flex', gap: 1 }}>
                            <Box
                              component="span"
                              sx={{
                                width: 22,
                                height: 22,
                                borderRadius: '50%',
                                backgroundColor: '#e7f7ef',
                                border: '1px solid #bee9d1',

                                display: 'inline-flex',
                                alignItems: 'center',
                                justifyContent: 'center',
                                flexShrink: 0,
                              }}
                            >
                              <Box
                                component="span"
                                sx={{
                                  color: '#16A34A',
                                  fontSize: 14,
                                  fontWeight: 600,
                                  lineHeight: 1,
                                }}
                              >
                                ✓
                              </Box>
                            </Box>
                            <Box>
                              Available <br />(
                              <strong style={{ fontWeight: 700 }}>
                                {' '}
                                $199.99
                              </strong>
                              /yr for a single entity)
                            </Box>
                          </Box>
                        </TableCell>
                        <TableCell
                          sx={{
                            textAlign: 'center !important',
                            fontWeight: '600 !important',
                            backgroundColor: '#e1f4fb !important',
                          }}
                        >
                          Unlimited Form 2290 & 8849 Filings
                          <Typography
                            component="div"
                            sx={{
                              backgroundColor: '#ECEAFB',
                              color: '#332C74',
                              border: '1px solid #D9D5F5',
                              fontWeight: 600,
                              fontSize: 11,
                              px: 1,
                              py: 0.2,
                              mt: 0.5,
                              borderRadius: 4,
                              display: 'inline-block',
                            }}
                          >
                            ★ Only TaxZerone
                          </Typography>
                        </TableCell>
                        <TableCell sx={{ textAlign: 'right ' }}>
                          <Box
                            sx={{
                              display: 'flex',
                              gap: 1,
                              justifyContent: 'flex-end',
                            }}
                          >
                            <Box>Not available</Box>
                            <Box
                              component="span"
                              sx={{
                                width: 22,
                                height: 22,
                                borderRadius: '50%',
                                backgroundColor: '#FCEEEF',
                                border: '1px solid #F2CBCF',

                                display: 'inline-flex',
                                alignItems: 'center',
                                justifyContent: 'center',
                                flexShrink: 0,
                              }}
                            >
                              <Box
                                component="span"
                                sx={{
                                  color: '#C63C4A',
                                  fontSize: 14,
                                  fontWeight: 600,
                                  lineHeight: 1,
                                }}
                              >
                                x
                              </Box>
                            </Box>
                          </Box>
                        </TableCell>
                      </TableRow>
                    </TableBody>
                  </Table>
                </Box>
              </TableContainer>
              <Typography
                variant="h3"
                sx={{
                  fontSize: { md: 20, sm: 18, xs: 16 },
                  fontWeight: 600,
                  mb: 0.5,
                  textAlign: 'left !important',
                }}
              >
                Support
              </Typography>
              <Typography variant="body1" sx={{ mb: 2 }}>
                How easy it is to get help when you need it.
              </Typography>
              <TableContainer
                sx={{
                  // border: '1px solid #e2e8f0',
                  overflowX: {
                    xs: 'auto',
                    md: 'unset',
                  },
                  background: '#ffffff',
                  // boxShadow: '0 8px 40px rgba(0, 0, 0, 0.2)',
                  mx: 'auto',
                  width: '100%',
                  // borderRadius: '12px',
                  overflow: 'hidden',
                  mb: 3,
                }}
              >
                <Box sx={{ minWidth: '840px' }}>
                  <Table
                    sx={{
                      minWidth: 600,
                      borderCollapse: 'collapse',
                      width: '100%',
                      borderSpacing: 0,
                      '& tbody tr:first-of-type td': {
                        borderTop: '2px solid #213e99',
                      },
                      '& tbody tr:last-of-type td': {
                        borderBottom: '1px solid #ccc',
                      },
                    }}
                  >
                    <TableHead>
                      <TableRow>
                        <TableCell
                          sx={{
                            textAlign: 'left',
                            width: 300,
                            fontWeight: 600,
                            fontSize: 16,
                            borderBottom: '2px solid #213e99  !important',
                            color: '#333',
                            backgroundColor: '#f7f9f9 !important',
                            borderLeft: '1px solid #ccc ',
                            borderTop: '1px solid #ccc',
                            // borderTopLeftRadius: 24,
                          }}
                        >
                          TaxZerone
                        </TableCell>
                        <TableCell
                          sx={{
                            borderBottom: 'none',
                            fontWeight: 500,
                            fontSize: { xs: 12, sm: 14, md: 16 },
                            width: 300,
                            textAlign: 'center',
                            backgroundColor: '#e1f4fb !important',
                            color: '#333',
                            borderTop: '1px solid #ccc',
                          }}
                        >
                          Support Channel
                        </TableCell>

                        <TableCell
                          sx={{
                            borderBottom: 'none',
                            textAlign: 'right',
                            width: 300,
                            backgroundColor: '#f7f9f9 !important',
                            color: '#333',
                            borderRight: '1px solid #ccc ',
                            borderTop: '1px solid #ccc',
                          }}
                        >
                          <Typography
                            component="span"
                            sx={{
                              fontSize: { xs: 12, sm: 14, md: 16 },
                              fontWeight: 600,
                              whiteSpace: 'nowrap',
                              // color: '#0f172a',
                            }}
                          >
                            SimpleTruckTax
                          </Typography>
                        </TableCell>
                      </TableRow>
                    </TableHead>

                    <TableBody
                      sx={{
                        borderLeft: '1px solid #ccc',
                        borderRight: '1px solid #ccc',
                        // borderBottom: '1px solid #ccc',
                        // borderRadius: '12px !important',
                        overflow: 'hidden',
                      }}
                    >
                      <TableRow
                        sx={{
                          borderTopRightRadius: 3,
                          backgroundColor: '#f5f5f5',
                        }}
                      >
                        <TableCell
                          sx={{
                            fontWeight: 500,
                            borderTop: ' 1px solid #ccc !important',
                          }}
                        >
                          <Box sx={{ display: 'flex', gap: 1 }}>
                            <Box
                              component="span"
                              sx={{
                                width: 22,
                                height: 22,
                                borderRadius: '50%',
                                backgroundColor: '#e7f7ef',
                                border: '1px solid #bee9d1',

                                display: 'inline-flex',
                                alignItems: 'center',
                                justifyContent: 'center',
                                flexShrink: 0,
                              }}
                            >
                              <Box
                                component="span"
                                sx={{
                                  color: '#16A34A',
                                  fontSize: 14,
                                  fontWeight: 600,
                                  lineHeight: 1,
                                }}
                              >
                                ✓
                              </Box>
                            </Box>

                            <Box>
                              Available <br />
                              [Monday to Friday, between 9 AM and 5 PM CST]
                            </Box>
                          </Box>
                        </TableCell>
                        <TableCell
                          sx={{
                            textAlign: 'center !important',
                            fontWeight: '600 !important',
                            backgroundColor: '#e1f4fb !important',
                          }}
                        >
                          Phone <br />{' '}
                          <span style={{ fontWeight: 'normal' }}>
                            {' '}
                            (English & Spanish)
                          </span>
                        </TableCell>
                        <TableCell sx={{ textAlign: 'right' }}>
                          <Box sx={{ display: 'flex', gap: 1 }}>
                            <Box>
                              Available <br />
                              [Monday to Friday, between 5 AM and 7 PM PST]
                            </Box>
                            <Box
                              component="span"
                              sx={{
                                width: 22,
                                height: 22,
                                borderRadius: '50%',
                                backgroundColor: '#e7f7ef',
                                border: '1px solid #bee9d1',

                                display: 'inline-flex',
                                alignItems: 'center',
                                justifyContent: 'center',
                                flexShrink: 0,
                              }}
                            >
                              <Box
                                component="span"
                                sx={{
                                  color: '#16A34A',
                                  fontSize: 14,
                                  fontWeight: 600,
                                  lineHeight: 1,
                                }}
                              >
                                ✓
                              </Box>
                            </Box>
                          </Box>
                        </TableCell>
                      </TableRow>

                      <TableRow>
                        <TableCell
                          sx={{
                            fontWeight: 500,
                          }}
                        >
                          <Box sx={{ display: 'flex', gap: 1 }}>
                            <Box
                              component="span"
                              sx={{
                                width: 22,
                                height: 22,
                                borderRadius: '50%',
                                backgroundColor: '#e7f7ef',
                                border: '1px solid #bee9d1',

                                display: 'inline-flex',
                                alignItems: 'center',
                                justifyContent: 'center',
                                flexShrink: 0,
                              }}
                            >
                              <Box
                                component="span"
                                sx={{
                                  color: '#16A34A',
                                  fontSize: 14,
                                  fontWeight: 600,
                                  lineHeight: 1,
                                }}
                              >
                                ✓
                              </Box>
                            </Box>
                            <Box>
                              Available <br />
                              [Monday to Friday, between 8 AM and 6 PM CST]
                            </Box>
                          </Box>
                        </TableCell>
                        <TableCell
                          sx={{
                            textAlign: 'center !important',
                            fontWeight: '600 !important',
                            backgroundColor: '#e1f4fb !important',
                          }}
                        >
                          Live Chat{' '}
                        </TableCell>
                        <TableCell sx={{ textAlign: 'right ' }}>
                          <Box
                            sx={{
                              display: 'flex',
                              gap: 1,
                              justifyContent: 'flex-end',
                            }}
                          >
                            <Box>
                              Available <br /> [Limited hours]{' '}
                            </Box>
                            <Box
                              component="span"
                              sx={{
                                width: 22,
                                height: 22,
                                borderRadius: '50%',
                                backgroundColor: '#e7f7ef',
                                border: '1px solid #bee9d1',

                                display: 'inline-flex',
                                alignItems: 'center',
                                justifyContent: 'center',
                                flexShrink: 0,
                              }}
                            >
                              <Box
                                component="span"
                                sx={{
                                  color: '#16A34A',
                                  fontSize: 14,
                                  fontWeight: 600,
                                  lineHeight: 1,
                                }}
                              >
                                ✓
                              </Box>
                            </Box>
                          </Box>
                        </TableCell>
                      </TableRow>

                      <TableRow sx={{ backgroundColor: '#f5f5f5' }}>
                        <TableCell
                          sx={{
                            fontWeight: 500,
                          }}
                        >
                          <Box sx={{ display: 'flex', gap: 1 }}>
                            <Box
                              component="span"
                              sx={{
                                width: 22,
                                height: 22,
                                borderRadius: '50%',
                                backgroundColor: '#e7f7ef',
                                border: '1px solid #bee9d1',

                                display: 'inline-flex',
                                alignItems: 'center',
                                justifyContent: 'center',
                                flexShrink: 0,
                              }}
                            >
                              <Box
                                component="span"
                                sx={{
                                  color: '#16A34A',
                                  fontSize: 14,
                                  fontWeight: 600,
                                  lineHeight: 1,
                                }}
                              >
                                ✓
                              </Box>
                            </Box>
                            <Box>
                              Available <br /> [24/7]
                            </Box>
                          </Box>
                        </TableCell>
                        <TableCell
                          sx={{
                            textAlign: 'center !important',
                            fontWeight: '600 !important',
                            backgroundColor: '#e1f4fb !important',
                          }}
                        >
                          Email
                        </TableCell>
                        <TableCell sx={{ textAlign: 'right' }}>
                          <Box sx={{ display: 'flex', gap: 1 }}>
                            <Box>
                              {' '}
                              Available <br /> [Monday to Friday, between 5 AM
                              and 7 PM PST]
                            </Box>
                            <Box
                              component="span"
                              sx={{
                                width: 22,
                                height: 22,
                                borderRadius: '50%',
                                backgroundColor: '#e7f7ef',
                                border: '1px solid #bee9d1',

                                display: 'inline-flex',
                                alignItems: 'center',
                                justifyContent: 'center',
                                flexShrink: 0,
                              }}
                            >
                              <Box
                                component="span"
                                sx={{
                                  color: '#16A34A',
                                  fontSize: 14,
                                  fontWeight: 600,
                                  lineHeight: 1,
                                }}
                              >
                                ✓
                              </Box>
                            </Box>
                          </Box>
                        </TableCell>
                      </TableRow>
                    </TableBody>
                  </Table>
                </Box>
              </TableContainer>

              <Alert
                icon={false}
                sx={{
                  backgroundColor: '#e0f2fe', // Light cyan background matching image
                  color: '#334155', // Soft slate text color
                  fontSize: { xs: '12px', sm: '13px' },
                  lineHeight: 1.5,
                  borderRadius: '12px',
                  padding: '12px 18px',
                  alignItems: 'center',
                  mb: 4,
                  width: '100%',
                  boxShadow: 'none',
                  '& .MuiAlert-icon': {
                    mr: 1.5,
                    padding: 0,
                  },
                  '& .MuiAlert-message': {
                    padding: 0,
                  },
                }}
              >
                <b>Note:</b> This comparison is based on publicly available
                information from their company website and other public sources.
                Features, pricing, and services may change over time. Please
                verify the latest information with the provider before making a
                decision.
              </Alert>
            </Grid>
          </Grid>
        </Container>
      </Grid>

      <Grid
        container
        sx={{
          backgroundColor: '#f6f6fa',
          mx: '0 !important',
          width: '100% !important',
          backgroundPosition: 'center bottom',
        }}
        spacing={2}
        m={0}
        component="section"
      >
        <Container maxWidth="lg" sx={{ px: { xs: 0, sm: 2 } }}>
          <Grid
            container
            spacing={2}
            m={2}
            mt={{ xs: 5, sm: 5, md: 6 }}
            mb={{ xs: 5, sm: 5, md: 8 }}
            className="MuiGrid-root-width"
          >
            <Box
              sx={{
                pt: 6,
                px: 2,
                maxWidth: '1200px',
                mx: 'auto',
                textAlign: 'center',
              }}
            >
              <Box textAlign="center" sx={{ mb: 1 }}>
                <Typography
                  variant="h3"
                  sx={{
                    fontSize: { lg: 34, md: 30, sm: 26, xs: 22 },
                    fontWeight: 600,

                    mb: 0,
                  }}
                >
                  Hear From Businesses That File Form 2290 with TaxZerone
                </Typography>
              </Box>

              <Grid container spacing={0} sx={{ mt: 0 }}>
                <Grid
                  size={{ xs: 12, sm: 6, md: 4 }}
                  sx={{
                    border: '1px solid #ccc',
                  }}
                >
                  <Box
                    component="a"
                    href="https://www.trustpilot.com/review/taxzerone.com"
                    target="_blank"
                    rel="noopener noreferrer"
                    sx={{
                      mt: 0,
                      display: 'inline-flex',
                      alignItems: 'center',
                      textDecoration: 'none',
                      cursor: 'pointer',
                      transition: 'transform 0.2s ease',
                      justifyContent: 'center',
                      textAlign: 'center',
                      mx: 'auto',
                    }}
                  >
                    <Box
                      sx={{
                        display: 'flex',
                        alignItems: 'center',
                        pr: 1.5,
                        mr: 1.5,
                        borderRight: '1px solid #e5e7eb',
                        height: 48,
                      }}
                    >
                      <Typography
                        sx={{
                          fontSize: { xs: 20, sm: 23 },
                          fontWeight: 600,
                          fontFamily: 'Arial, sans-serif',
                          color: '#00b67a',
                          letterSpacing: '-0.5px',
                          lineHeight: 1,
                          whiteSpace: 'nowrap',
                        }}
                      >
                        Trustpilot
                      </Typography>
                    </Box>

                    <Box
                      sx={{
                        display: 'flex',
                        flexDirection: 'column',
                        alignItems: 'flex-start',
                      }}
                    >
                      <Stack
                        direction="row"
                        alignItems="center"
                        spacing={0.7}
                        sx={{
                          height: 20,
                        }}
                      >
                        <Typography
                          sx={{
                            fontSize: 14,
                            fontWeight: 700,
                            color: '#172b4d',
                            lineHeight: 1,
                          }}
                        >
                          Excellent
                        </Typography>

                        <Typography
                          sx={{
                            fontSize: 14,
                            fontWeight: 700,
                            color: '#172b4d',
                            lineHeight: 1,
                          }}
                        >
                          4.4
                        </Typography>
                      </Stack>

                      <Stack
                        direction="row"
                        spacing={0.35}
                        sx={{
                          mt: 0.6,
                        }}
                      >
                        {/* Star 1 */}
                        <Box
                          sx={{
                            width: 20,
                            height: 20,
                            backgroundColor: '#00b67a',
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                          }}
                        >
                          <Typography
                            sx={{
                              color: '#fff',
                              fontSize: 14,
                              lineHeight: 1,
                            }}
                          >
                            ★
                          </Typography>
                        </Box>

                        {/* Star 2 */}
                        <Box
                          sx={{
                            width: 20,
                            height: 20,
                            backgroundColor: '#00b67a',
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                          }}
                        >
                          <Typography
                            sx={{
                              color: '#fff',
                              fontSize: 14,
                              lineHeight: 1,
                            }}
                          >
                            ★
                          </Typography>
                        </Box>

                        {/* Star 3 */}
                        <Box
                          sx={{
                            width: 20,
                            height: 20,
                            backgroundColor: '#00b67a',
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                          }}
                        >
                          <Typography
                            sx={{
                              color: '#fff',
                              fontSize: 14,
                              lineHeight: 1,
                            }}
                          >
                            ★
                          </Typography>
                        </Box>

                        {/* Star 4 */}
                        <Box
                          sx={{
                            width: 20,
                            height: 20,
                            backgroundColor: '#00b67a',
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                          }}
                        >
                          <Typography
                            sx={{
                              color: '#fff',
                              fontSize: 14,
                              lineHeight: 1,
                            }}
                          >
                            ★
                          </Typography>
                        </Box>

                        {/* Star 5 - 40% for 4.4 rating */}
                        <Box
                          sx={{
                            width: 20,
                            height: 20,
                            position: 'relative',
                            overflow: 'hidden',
                            backgroundColor: '#d9d9d9',
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                          }}
                        >
                          {/* Grey Star */}
                          <Typography
                            sx={{
                              position: 'absolute',
                              color: '#ffffff',
                              fontSize: 14,
                              lineHeight: 1,
                            }}
                          >
                            ★
                          </Typography>

                          {/* Green 40% Star */}
                          <Box
                            sx={{
                              position: 'absolute',
                              left: 0,
                              top: 0,
                              width: '40%',
                              height: '100%',
                              overflow: 'hidden',
                              backgroundColor: '#00b67a',
                              display: 'flex',
                              alignItems: 'center',
                              justifyContent: 'flex-start',
                            }}
                          >
                            <Typography
                              sx={{
                                width: 20,
                                minWidth: 20,
                                color: '#ffffff',
                                fontSize: 14,
                                lineHeight: 1,
                                textAlign: 'center',
                              }}
                            >
                              ★
                            </Typography>
                          </Box>
                        </Box>
                      </Stack>
                    </Box>
                  </Box>
                </Grid>
                <Grid
                  size={{ xs: 12, sm: 6, md: 4 }}
                  sx={{ border: '1px solid #ccc', borderLeft: 'unset' }}
                >
                  <Box
                    sx={{
                      display: 'flex',
                      textAlign: 'left',
                      gap: 1.2,
                      justifyContent: 'center',
                    }}
                  >
                    <Box>
                      <picture>
                        <source srcSet="/assets/images/google-reviews.webp" />
                        <source srcSet="/assets/images/google-reviews.png" />
                        <Box
                          component="img"
                          src="/assets/images/google-reviews.png"
                          loading="lazy"
                          alt="Google Review"
                          width={53}
                          height={58}
                          sx={{
                            width: { xs: 50, md: 53 },
                            height: { xs: 49, md: 58 },
                          }}
                        />
                      </picture>
                    </Box>
                    <Box sx={{ textAlign: 'left' }}>
                      <Typography variant="body1" sx={{ fontWeight: 600 }}>
                        Reviews 5.0
                      </Typography>
                      <Rating
                        value={5}
                        readOnly
                        size="small"
                        sx={{ color: '#EAB308' }}
                      />
                    </Box>
                  </Box>
                </Grid>
                <Grid
                  size={{ xs: 12, sm: 6, md: 4 }}
                  sx={{
                    border: '1px solid #ccc',
                    borderLeft: 'unset',
                  }}
                >
                  <Box
                    sx={{
                      display: 'flex',
                      textAlign: 'left',
                      gap: 1.2,
                      justifyContent: 'center',
                    }}
                  >
                    <Box>
                      <picture>
                        <source srcSet="/assets/images/g2-logo-img.webp" />
                        <source srcSet="/assets/images/g2-logo-img.png" />
                        <Box
                          component="img"
                          src="/assets/images/g2-logo-img.png"
                          loading="lazy"
                          alt="G2 logo"
                          width={53}
                          height={58}
                          sx={{
                            width: { xs: 50, md: 53 },
                            height: { xs: 49, md: 58 },
                          }}
                        />
                      </picture>
                    </Box>
                    <Box sx={{ textAlign: 'left' }}>
                      <Typography variant="body1" sx={{ fontWeight: 600 }}>
                        Reviews 5.0
                      </Typography>
                      <Rating
                        value={5}
                        readOnly
                        size="small"
                        sx={{ color: '#EAB308' }}
                      />
                    </Box>
                  </Box>
                </Grid>
                <Grid size={{ xs: 12, md: 4 }} sx={{ px: 2, mt: 4 }}>
                  <Stack spacing={3}>
                    <Paper
                      elevation={0}
                      sx={{
                        p: 3,
                        borderRadius: '16px',
                        border: '1px solid #E2E8F0',
                        backgroundColor: '#ffffff',
                      }}
                    >
                      <Typography
                        variant="body2"
                        sx={{
                          color: '#475569',
                          lineHeight: 1.6,
                          fontSize: '14px',
                          mb: 2,
                        }}
                      >
                        TaxZerone made filing Form 2290 much easier. It saved me
                        a lot of time compared to my previous filing experience.
                      </Typography>
                      <Rating
                        value={5}
                        readOnly
                        size="small"
                        sx={{ color: '#838383', mb: 1.5 }}
                      />
                      <Typography
                        variant="subtitle2"
                        sx={{
                          fontWeight: 600,
                          color: '#0F172A',
                          fontSize: '15px',
                        }}
                      >
                        Daniel Reed
                      </Typography>
                    </Paper>

                    {/* <Paper
                      elevation={0}
                      sx={{
                        p: 3,
                        borderRadius: '16px',
                        backgroundColor: '#E0F2FE', // Light blue fill
                      }}
                    >
                      <Typography
                        variant="body2"
                        sx={{
                          color: '#334155',
                          lineHeight: 1.6,
                          fontSize: '14px',
                          mb: 2,
                        }}
                      >
                        The phone support team was really patient and walked me
                        through everything step by step. I had no tax knowledge
                        at all going in. TaxZerone made the whole process feel
                        easy and gave me confidence. 10/10.
                      </Typography>
                      <Rating
                        value={5}
                        readOnly
                        size="small"
                        sx={{ color: '#64748B', mb: 1.5 }}
                      />
                      <Typography
                        variant="subtitle2"
                        sx={{
                          fontWeight: 700,
                          color: '#0F172A',
                          fontSize: '15px',
                        }}
                      >
                        Elizabeth Wagner
                      </Typography>
                    </Paper> */}
                  </Stack>
                </Grid>

                <Grid size={{ xs: 12, md: 4 }} sx={{ px: 2, mt: 4 }}>
                  <Stack spacing={3}>
                    <Paper
                      elevation={0}
                      sx={{
                        p: 3,
                        borderRadius: '16px',
                        backgroundColor: '#e2dafc',
                      }}
                    >
                      <Typography
                        variant="body2"
                        sx={{
                          color: '#334155',
                          lineHeight: 1.6,
                          fontSize: '14px',
                          mb: 2,
                        }}
                      >
                        I sold my old truck and bought a new one. So, I wasn't
                        sure how to handle the filing. Alexia walked me the
                        right way and made the filing process simple.
                      </Typography>
                      <Rating
                        value={5}
                        readOnly
                        size="small"
                        sx={{ color: '#838383', mb: 1.5 }}
                      />
                      <Typography
                        variant="subtitle2"
                        sx={{
                          fontWeight: 600,
                          color: '#0F172A',
                          fontSize: '15px',
                        }}
                      >
                        Mike Reynolds
                      </Typography>
                    </Paper>
                    {/* 
                    <Paper
                      elevation={0}
                      sx={{
                        p: 3,
                        borderRadius: '16px',
                        border: '1px solid #E2E8F0',
                        backgroundColor: '#ffffff',
                      }}
                    >
                      <Typography
                        variant="body2"
                        sx={{
                          color: '#475569',
                          lineHeight: 1.6,
                          fontSize: '14px',
                          mb: 2,
                        }}
                      >
                        Really good chat support experience. I wasn&apos;t sure
                        how to complete a few steps, but Kevin guided me clearly
                        and stayed with me until everything was done. Appreciate
                        the help.
                      </Typography>
                      <Rating
                        value={5}
                        readOnly
                        size="small"
                        sx={{ color: '#64748B', mb: 1.5 }}
                      />
                      <Typography
                        variant="subtitle2"
                        sx={{
                          fontWeight: 700,
                          color: '#0F172A',
                          fontSize: '15px',
                        }}
                      >
                        Joseph J Perez
                      </Typography>
                    </Paper> */}
                  </Stack>
                </Grid>

                <Grid size={{ xs: 12, md: 4 }} sx={{ px: 2, mt: 4 }}>
                  <Stack spacing={3}>
                    <Paper
                      elevation={0}
                      sx={{
                        p: 3,
                        borderRadius: '16px',
                        border: '1px solid #E2E8F0',
                        backgroundColor: '#ffffff',
                      }}
                    >
                      <Typography
                        variant="body2"
                        sx={{
                          color: '#475569',
                          lineHeight: 1.6,
                          fontSize: '14px',
                          mb: 2,
                        }}
                      >
                        The support team responded quickly to my
                        trucking related questions. Overall, it was a smooth
                        filing experience from start to finish.
                      </Typography>
                      <Rating
                        value={5}
                        readOnly
                        size="small"
                        sx={{ color: '#838383', mb: 1.5 }}
                      />
                      <Typography
                        variant="subtitle2"
                        sx={{
                          fontWeight: 600,
                          color: '#0F172A',
                          fontSize: '15px',
                        }}
                      >
                        Justin Allen
                      </Typography>
                    </Paper>

                    {/* <Paper
                      elevation={0}
                      sx={{
                        p: 3,
                        borderRadius: '16px',
                        backgroundColor: '#FEF3C7', // Light yellow fill
                      }}
                    >
                      <Typography
                        variant="body2"
                        sx={{
                          color: '#334155',
                          lineHeight: 1.6,
                          fontSize: '14px',
                          mb: 2,
                        }}
                      >
                        OMG! I cannot believe how wonderful the live support
                        was. The agent Alexia assisted me with everything I
                        needed and fixed all the issues in the most professional
                        and friendly manner. Amazing customer experience. Thank
                        You!
                      </Typography>
                      <Rating
                        value={5}
                        readOnly
                        size="small"
                        sx={{ color: '#64748B', mb: 1.5 }}
                      />
                      <Typography
                        variant="subtitle2"
                        sx={{
                          fontWeight: 700,
                          color: '#0F172A',
                          fontSize: '15px',
                        }}
                      >
                        Luis Echenique
                      </Typography>
                    </Paper> */}
                  </Stack>
                </Grid>
              </Grid>
            </Box>
          </Grid>
        </Container>
      </Grid>
      <Grid
        container
        sx={{
          backgroundColor: '#fff',
          mx: '0 !important',
          width: '100% !important',
        }}
        spacing={2}
        m={0}
        component="section"
      >
        <Container maxWidth="lg" sx={{ mb: 5, mt: 5 }}>
          <Box
            sx={{ py: 4, px: { xs: 2, md: 4 }, maxWidth: '1100px', mx: 'auto' }}
          >
            {/* HEADING */}
            <Typography
              variant="h2"
              sx={{
                fontSize: { lg: 34, md: 30, sm: 26, xs: 22 },
                fontWeight: 600,
                textAlign: 'center',
                mb: 5,
              }}
            >
              Key Summary Takeaways:
            </Typography>

            <Stack
              spacing={4}
              direction={{ xs: 'column', md: 'row' }}
              sx={{ mt: 0 }}
            >
              <Box
                sx={{
                  p: { xs: 2.5, sm: 3 },
                  borderRadius: 2,
                  backgroundColor: '#f1f8ff',
                  border: '1px solid #a9b5c5',
                  width: '100%',
                }}
              >
                <Typography
                  variant="h3"
                  sx={{
                    fontWeight: 600,
                    fontSize: { xs: 16, sm: 18 },
                    mb: 2,
                    color: '#213e99',
                  }}
                >
                  Choose TaxZerone if you:
                </Typography>
                <Stack spacing={1.2}>
                  <Box
                    sx={{
                      display: 'flex',
                      gap: 1,
                      alignItems: 'flex-start',
                    }}
                  >
                    <CheckCircleIcon sx={{ fontSize: 24, color: '#16A34A' }} />
                    <Typography variant="body2" sx={{ color: '#334155' }}>
                      Manage a large fleet and want predictable pricing for
                      <br />
                      high-volume filing.
                    </Typography>
                  </Box>
                  <Box
                    sx={{
                      display: 'flex',
                      gap: 1,
                      alignItems: 'flex-start',
                    }}
                  >
                    <CheckCircleIcon sx={{ fontSize: 24, color: '#16A34A' }} />
                    <Typography variant="body2" sx={{ color: '#334155' }}>
                      Prefer a faster, more intuitive Form 2290 filing
                      experience.
                    </Typography>
                  </Box>
                  <Box
                    sx={{
                      display: 'flex',
                      gap: 1,
                      alignItems: 'flex-start',
                    }}
                  >
                    <CheckCircleIcon sx={{ fontSize: 24, color: '#16A34A' }} />
                    <Typography variant="body2" sx={{ color: '#334155' }}>
                      Want flexible filing options, including online, phone,
                      email, and live chat assistance.
                    </Typography>
                  </Box>
                  <Box
                    sx={{
                      display: 'flex',
                      gap: 1,
                      alignItems: 'flex-start',
                    }}
                  >
                    <CheckCircleIcon sx={{ fontSize: 24, color: '#16A34A' }} />
                    <Typography variant="body2" sx={{ color: '#334155' }}>
                      Need fleet-friendly features such as bulk upload, free VIN
                      corrections, and personalized filing support.
                    </Typography>
                  </Box>
                  <Box
                    sx={{
                      display: 'flex',
                      gap: 1,
                      alignItems: 'flex-start',
                    }}
                  >
                    <CheckCircleIcon sx={{ fontSize: 24, color: '#16A34A' }} />
                    <Typography variant="body2" sx={{ color: '#334155' }}>
                      Value responsive US-based bilingual customer support
                      (English & Spanish)
                    </Typography>
                  </Box>
                </Stack>
              </Box>

              <Box
                sx={{
                  p: { xs: 2.5, sm: 3 },
                  borderRadius: 2,
                  backgroundColor: '#fff',
                  border: '1px solid #e3e3e3',
                  width: '100%',
                }}
              >
                <Typography
                  sx={{
                    fontWeight: 600,
                    fontSize: '16px',
                    mb: 2,
                    color: '#637381',
                  }}
                >
                  Choose SimpleTruckTax if you:
                </Typography>
                <Stack spacing={1.2}>
                  <Box
                    sx={{
                      display: 'flex',
                      gap: 1,
                      alignItems: 'flex-start',
                    }}
                  >
                    <CheckIcon
                      sx={{ fontSize: 18, color: '#16A34A', mt: '2px' }}
                    />
                    <Typography
                      variant="body2"
                      sx={{ color: '#637381', fontSize: '13px' }}
                    >
                      Are an owner-operator or small fleet looking for a
                      straightforward online filing experience.
                    </Typography>
                  </Box>
                  <Box
                    sx={{
                      display: 'flex',
                      gap: 1,
                      alignItems: 'flex-start',
                    }}
                  >
                    <CheckIcon
                      sx={{ fontSize: 18, color: '#16A34A', mt: '2px' }}
                    />
                    <Typography
                      variant="body2"
                      sx={{ color: '#637381', fontSize: '13px' }}
                    >
                      Primarily need standard Form 2290 filing features.
                    </Typography>
                  </Box>
                  <Box
                    sx={{
                      display: 'flex',
                      gap: 1,
                      alignItems: 'flex-start',
                    }}
                  >
                    <CheckIcon
                      sx={{ fontSize: 18, color: '#16A34A', mt: '2px' }}
                    />
                    <Typography
                      variant="body2"
                      sx={{ color: '#637381', fontSize: '13px' }}
                    >
                      Prefer handling your filing yourself with minimal
                      assistance.
                    </Typography>
                  </Box>
                </Stack>
              </Box>
            </Stack>
          </Box>
        </Container>
      </Grid>
      <Box
        component="section"
        sx={{
          backgroundColor: '#1da94a',
          py: { lg: 8, md: 8, sm: 4, xs: 4 },
          mx: '0 !important',
          width: '100% !important',
          mb: 0,
          p: 2,
          textAlign: 'center',
        }}
        m={2}
        mt={0}
        className="curve-bg"
      >
        <Typography
          variant="h2"
          color="white"
          sx={{
            fontSize: { lg: 34, md: 30, sm: 26, xs: 22 },
            fontWeight: 600,
            mb: 3,
            lineHeight: 1.2,
          }}
        >
          Ready to File with TaxZerone?
        </Typography>

        <Typography
          variant="body1"
          sx={{
            fontSize: {
              xs: 16,
              sm: 18,
              md: 18,
              lg: 20,
              xl: 22,
            },
            fontWeight: 400,
            color: '#f3f3f3',
            mb: 2,
            lineHeight: 1.5,
          }}
        >
          Get your IRS-stamped Schedule 1 quickly after IRS acceptance.{' '}
          <Hidden smDown>
            <br />{' '}
          </Hidden>{' '}
          Start your Form 2290 filing online in just a few steps.
        </Typography>
        <Box component="div" sx={{ margin: 'auto' }}>
          <Button
            variant="contained"
            sx={{
              mt: { xs: 0, sm: 4 },
              mb: { xs: 0, md: 0 },
              color: '#444',
              transition: 'all 0.3s ease 0s',
              '&:hover, &active': {
                backgroundColor: '#213e99 !important',
                color: '#fff',
                transform: 'scale(1.1)',
              },
            }}
            className="btn-secondary-white"
            href={`${process.env.NEXT_PUBLIC_APPLICATION_URL}signup/?ref=taxzerone-vs-simpletruck`}
          >
            Get Started
          </Button>
          <Box
            sx={{
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              gap: 3,
              mt: 2,
              flexWrap: 'wrap',
            }}
          >
            <Typography sx={{ color: '#f3f3f3' }}>
              Receive your schedule 1 in minutes
            </Typography>
          </Box>
        </Box>
      </Box>
      <Grid
        container
        sx={{
          backgroundColor: '#ffffff',
          mx: '0 !important',
          width: '100% !important',
          py: 2,
        }}
        spacing={0}
        m={0}
        component="section"
        aria-labelledby="comparison-faq"
      >
        <Container maxWidth="lg" sx={{ mb: 0 }}>
          <Grid
            container
            spacing={2}
            m={2}
            direction="row"
            justifyContent="center"
            className="MuiGrid-root-width"
            sx={{ my: { xs: 0, sm: 2, md: 2 } }}
          >
            <Grid
              size={{ xs: 12, sm: 10, md: 9 }}
              textAlign="left"
              mt={{ xs: 2, sm: 1 }}
              mb={2}
            >
              <Typography
                variant="h2"
                id="comparison-faq"
                sx={{
                  fontSize: { lg: 34, md: 30, sm: 26, xs: 22 },
                  fontWeight: 600,
                  mb: 5,
                  textAlign: 'center',
                }}
              >
                Frequently Asked Questions
              </Typography>

              <Box
                component="div"
                sx={{ mb: 0 }}
                itemScope
                itemType="https://schema.org/FAQPage"
              >
                <Box
                  component="article"
                  itemScope
                  itemProp="mainEntity"
                  itemType="https://schema.org/Question"
                  sx={{
                    border: '1px solid rgba(145, 158, 171, 0.35)',
                    p: 2,
                    mb: 2,
                    backgroundColor: '#fff',
                  }}
                >
                  <Typography
                    variant="h3"
                    sx={{
                      fontWeight: 600,
                      color: '#36324a',
                      fontSize: { lg: 20, md: 18, sm: 18, xs: 18 },
                    }}
                    itemProp="name"
                  >
                    What are the main differences between TaxZerone and
                    SimpleTruckTax?
                  </Typography>
                  <Box
                    itemScope
                    itemProp="acceptedAnswer"
                    itemType="https://schema.org/Answer"
                  >
                    <Box itemProp="text">
                      <Box component="ul" sx={{ mb: 0, '& li': { mb: 1.2 } }}>
                        <li>
                          The main differences between TaxZerone and
                          SimpleTruckTax include their filing workflow, support
                          options, convenience features, and the range of tax
                          forms they support.
                        </li>
                        <li>
                          <strong style={{ fontWeight: 600 }}>TaxZerone</strong>{' '}
                          provides guided and assisted Form 2290 filing through
                          phone, email, and live chat, along with bulk VIN
                          uploads, free VIN corrections, and free retransmission
                          for rejected returns.
                        </li>
                        <li>
                          TaxZerone also supports e-filing for{' '}
                          <strong style={{ fontWeight: 600 }}>
                            multiple IRS tax forms
                          </strong>{' '}
                          including 1099 series, 1098 series, <br /> W-2, ACA
                          forms, Form 2290, 990 series, business tax forms,
                          extension forms, state filings, and many more., giving
                          businesses and tax professionals options beyond Form
                          2290.
                        </li>
                        <li>
                          <strong style={{ fontWeight: 600 }}>
                            {' '}
                            SimpleTruckTax
                          </strong>{' '}
                          primarily focuses on{' '}
                          <strong style={{ fontWeight: 600 }}>
                            {' '}
                            Form 2290 and related truck-tax filing needs,
                          </strong>{' '}
                          with a self-service online filing experience designed
                          for users who prefer to complete their returns
                          independently.
                        </li>
                      </Box>
                    </Box>
                  </Box>
                </Box>

                <Box
                  component="article"
                  itemScope
                  itemProp="mainEntity"
                  itemType="https://schema.org/Question"
                  sx={{
                    border: '1px solid rgba(145, 158, 171, 0.35)',
                    p: 2,
                    mb: 2,
                    backgroundColor: '#fff',
                  }}
                >
                  <Typography
                    variant="h3"
                    sx={{
                      fontWeight: 600,
                      color: '#36324a',
                      fontSize: { lg: 20, md: 18, sm: 18, xs: 18 },
                    }}
                    itemProp="name"
                  >
                    Is TaxZerone better than SimpleTruckTax for high volume
                    filers?
                  </Typography>
                  <Box
                    itemScope
                    itemProp="acceptedAnswer"
                    itemType="https://schema.org/Answer"
                  >
                    <Box itemProp="text">
                      <Box component="ul" sx={{ mb: 0, '& li': { mb: 1.2 } }}>
                        <li>
                          Yes, TaxZerone is a strong choice for high-volume Form
                          2290 filers because it includes tools that reduce
                          manual work.
                        </li>
                        <li>
                          Features such as bulk VIN uploads, saved business
                          information, secure file upload (Converts your file
                          into the required format), multi-vehicle filing, free
                          VIN corrections, and free retransmission help
                          businesses, fleets, and tax professionals file faster.
                        </li>
                        <li>
                          These capabilities make it easier to manage multiple
                          returns from a single platform.
                        </li>
                      </Box>
                    </Box>
                  </Box>
                </Box>

                <Box
                  component="article"
                  itemScope
                  itemProp="mainEntity"
                  itemType="https://schema.org/Question"
                  sx={{
                    border: '1px solid rgba(145, 158, 171, 0.35)',
                    p: 2,
                    mb: 2,
                    backgroundColor: '#fff',
                  }}
                >
                  <Typography
                    variant="h3"
                    sx={{
                      fontWeight: 600,
                      color: '#36324a',
                      fontSize: { lg: 20, md: 18, sm: 18, xs: 18 },
                    }}
                    itemProp="name"
                  >
                    Can I switch from SimpleTruckTax to TaxZerone easily?
                  </Typography>
                  <Box
                    itemScope
                    itemProp="acceptedAnswer"
                    itemType="https://schema.org/Answer"
                  >
                    <Box itemProp="text">
                      <Box component="ul" sx={{ mb: 0, '& li': { mb: 1.2 } }}>
                        <li>
                          Yes, you can switch to TaxZerone by creating an
                          account and entering or importing your business and
                          vehicle information.
                        </li>
                        <li>
                          There is no complicated migration process, and you can
                          begin filing new Form 2290 returns right away.
                        </li>
                        <li>
                          If you need help during the transition, TaxZerone
                          provides support through phone, email, and live chat.
                        </li>
                      </Box>
                    </Box>
                  </Box>
                </Box>
                <Box
                  component="article"
                  itemScope
                  itemProp="mainEntity"
                  itemType="https://schema.org/Question"
                  sx={{
                    border: '1px solid rgba(145, 158, 171, 0.35)',
                    p: 2,
                    mb: 2,
                    backgroundColor: '#fff',
                  }}
                >
                  <Typography
                    variant="h3"
                    sx={{
                      fontWeight: 600,
                      color: '#36324a',
                      fontSize: { lg: 20, md: 18, sm: 18, xs: 18 },
                    }}
                    itemProp="name"
                  >
                    Which platform is better for accountants and service
                    providers?
                  </Typography>
                  <Box
                    itemScope
                    itemProp="acceptedAnswer"
                    itemType="https://schema.org/Answer"
                  >
                    <Box itemProp="text">
                      <Box component="ul" sx={{ mb: 0, '& li': { mb: 1.2 } }}>
                        <li>
                          TaxZerone is generally a better fit for accountants,
                          tax preparers, and service providers who file Form
                          2290 returns for multiple clients.
                        </li>
                        <li>
                          It offers bulk filing, client data management,
                          multi-user capabilities, and tools that help reduce
                          repetitive data entry.
                        </li>
                        <li>
                          These features can improve efficiency and simplify
                          managing multiple businesses or fleets from one
                          account.
                        </li>
                      </Box>
                    </Box>
                  </Box>
                </Box>
              </Box>
            </Grid>
          </Grid>
        </Container>
      </Grid>
    </AppLayout>
  );
};

export default BestForm941Software;
